import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import * as XLSX from "xlsx";
import axios from "axios";
import {
  FileUploadToServernew,
  SheetData,
  SheetDataUpload,
  UploadEditSheetData,
} from "../../../services/auth-service/authService.js";
import { Fetchexecutequery, Fetchheaderdata, Fetchupdatequery } from '../../../services/process/BRS1/brsService1';

// --- Constants ----------------------------------------------------------------

const LOAD_OPTIONS = [
  { value: "append", label: "Append" },
  { value: "replace", label: "Replace" }
];

function TableConfigPanel({ config, setConfig }) {

  const update = (key, value) => {
    setConfig(prev => ({
      ...prev,
      [key]: value
    }));
  };

  return (
    <div className="sd-card">
      <div className="sd-card-title">Table Configuration</div>

      <div className="sd-fields-row">

        <div className="sd-field">
          <label className="sd-label">Table Name</label>
          <input
            className="sd-input"
            value={config?.tableName || ""}
            onChange={e => update("tableName", e.target.value)}
          />
        </div>

        <div className="sd-field">
          <label className="sd-label">Primary Key</label>
          <input
            className="sd-input"
            value={config?.primaryKey || ""}
            onChange={e => update("primaryKey", e.target.value)}
          />
        </div>

        <div className="sd-field">
          <label className="sd-label">Load Type</label>
          <Select
            options={LOAD_OPTIONS}
            value={
              config?.loadType
                ? LOAD_OPTIONS.find(o => o.value === config.loadType)
                : null
            }
            onChange={v => update("loadType", v?.value)}
            classNamePrefix="react-select"
          />
        </div>

      </div>
    </div>
  );
}

const SOURCE_TYPE_OPTIONS = [
  { value: "Excel", label: "Excel" },
  { value: "CSV", label: "CSV" },
  { value: "Text", label: "Text" },
  { value: "Staging DB", label: "Staging DB" },
  { value: "Binary", label: "Binary" },
];

const DATA_TYPE_OPTIONS = [
  { value: "", label: " type " },
  { value: "date", label: "Date" },
  { value: "decimal", label: "Decimal" },
  { value: "integer", label: "Integer" },
  { value: "text", label: "Text" },
  { value: "time", label: "Time" },
];

const COL_TRANSFORM_OPTIONS = [
  { value: "Change Date Format", label: "Change Date Format" },
  { value: "Field Extraction", label: "Field Extraction" },
  { value: "Position", label: "Position" },
  { value: "Change Column Name", label: "Change Column Name" },
  { value: "Transaction Identifier", label: "Transaction Identifier" },
  { value: "Fill Rows", label: "Fill Rows" },
  { value: "Renaming Columns", label: "Renaming Columns" },
  { value: "Value Corrections", label: "Value Corrections" },
];

const CONSOLIDATED_TRANSFORM_OPTIONS = [
  { value: "Duplicate Check", label: "Duplicate Check" },
  { value: "Drop Rows/Columns", label: "Drop Rows/Columns" },
  { value: "Keep Columns", label: "Keep Columns" },
];

const IDENTIFIER_TYPE_OPTIONS = [
  { value: "string", label: "String" },
  { value: "int", label: "Integer" },
  { value: "special_chars", label: "Special Characters" },
  { value: "contains", label: "Contains" },
  { value: "starts_with", label: "Starts With" },
  { value: "ends_with", label: "Ends With" },
];

const DATE_FORMAT_OPTIONS = [
  { value: "%d-%m-%Y", label: "dd-mm-yyyy" },
  { value: "%m-%d-%Y", label: "mm-dd-yyyy" },
  { value: "%Y-%m-%d", label: "yyyy-mm-dd" },
  { value: "%d/%m/%Y", label: "dd/mm/yyyy" },
  { value: "%m/%d/%Y", label: "mm/dd/yyyy" },
  { value: "%Y/%m/%d", label: "yyyy/mm/dd" },
  { value: "%d-%b-%Y", label: "dd-Mon-yyyy" },
  { value: "%Y-%m-%d %H:%M:%S", label: "yyyy-mm-dd hh:mm:ss" },
  { value: "%d-%m-%Y %H:%M:%S", label: "dd-mm-yyyy hh:mm:ss" },
  { value: "%H:%M:%S", label: "hh:mm:ss" },
  { value: "%H:%M", label: "hh:mm" },
];

const COL_LETTER_OPTS = (() => {
  const opts = [];
  for (let i = 0; i < 26; i++) opts.push({ value: String.fromCharCode(65 + i), label: String.fromCharCode(65 + i) });
  for (let i = 0; i < 26; i++) for (let j = 0; j < 26; j++) {
    opts.push({ value: String.fromCharCode(65 + i) + String.fromCharCode(65 + j), label: String.fromCharCode(65 + i) + String.fromCharCode(65 + j) });
  }
  return opts;
})();
const ROW_NUM_OPTS = Array.from({ length: 200 }, (_, i) => ({ value: String(i + 1), label: String(i + 1) }));

const DB_OPTS = [{ value: "mysql", label: "MySQL" }];
const COLTYPE_OPTS = [{ value: "data_entry", label: "Data Entry" }, { value: "database", label: "Database" }];
const SRC_DB_OPTS = [{ value: "source", label: "Source" }, { value: "database", label: "Database" }];
const CORR_OPTS = [{ value: "replace_values", label: "Replace Values" }, { value: "date_format", label: "Date Format Correction" }];
const DROP_OPTS = [
  { value: "value", label: "Drop by Value" },
  { value: "index", label: "Drop by Row Index" },
  { value: "empty_row", label: "Drop Empty Rows" },
  { value: "after_empty_cell", label: "Drop After Empty Cell" },
  { value: "drop_columns", label: "Drop Columns" },
  { value: "delete_rows", label: "Delete Rows (Condition)" },
];
const FILL_OPTS = [
  { value: "fill_nulls", label: "Fill Empty Cells" },
  { value: "fill_cell_values", label: "Fill from Cell Reference" },
  { value: "column_splitter", label: "Column Splitter" },
];
const DELCOND_OPTS = [
  { value: "null_rows", label: "Empty Rows" },
  { value: "non_null_rows", label: "Non-Empty Rows" },
  { value: "index", label: "Row Index" },
];
const DROPCOND_OPTS = [
  { value: "column_index", label: "By Column Index" },
  { value: "column_name", label: "By Column Name" },
];

// --- CSS ----------------------------------------------------------------------

const css = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .sd-root { font-family: 'DM Sans', sans-serif; background: #f7f7f8; min-height: 100vh; padding: 0.7rem 1rem; color: #111; font-size: 0.82rem; }

  .sd-card { background: #fff; border: 1.5px solid #e0e0e0; border-radius: 18px; padding: 0.8rem 1rem; margin-bottom: 0.55rem; }
  .sd-card-title { font-size: 0.6rem; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: #444; margin-bottom: 0; }

  .sd-field { display: flex; flex-direction: column; gap: 0.15rem; flex: 1; min-width: 0; }
  .sd-label { font-size: 0.6rem; font-weight: 700; color: #333; letter-spacing: 0.06em; text-transform: uppercase; white-space: nowrap; }
  .sd-input { font-family: 'DM Sans', sans-serif; font-size: 0.81rem; padding: 0.28rem 0.65rem; border: 1.5px solid #ccc; border-radius: 999px; outline: none; background: #fff; transition: border-color 0.15s; width: 100%; color: #111; height: 28px; }
  .sd-input:focus { border-color: #4f6ef7; box-shadow: 0 0 0 2px rgba(79,110,247,0.1); }
  .sd-input:disabled { opacity: 0.4; cursor: not-allowed; background: #f9f9f9; }
  .sd-input[type="file"] { cursor: pointer; padding: 0.18rem 0.65rem; }
  .sd-input::placeholder { color: #aaa; }

  .sd-btn { font-family: 'DM Sans', sans-serif; font-size: 0.74rem; font-weight: 600; padding: 0.28rem 0.85rem; border: none; border-radius: 999px; cursor: pointer; transition: all 0.15s; display: inline-flex; align-items: center; gap: 0.28rem; white-space: nowrap; height: 28px; }
  .sd-btn-primary   { background: #111; color: #fff; }
  .sd-btn-primary:hover   { background: #333; }
  .sd-btn-secondary { background: #fff; color: #111; border: 1.5px solid #ccc; }
  .sd-btn-secondary:hover { background: #f5f5f5; }
  .sd-btn-success   { background: #16a34a; color: #fff; }
  .sd-btn-success:hover   { background: #15803d; }
  .sd-btn-danger    { background: #dc2626; color: #fff; }
  .sd-btn-sm { height: 22px; padding: 0.15rem 0.6rem; font-size: 0.68rem; }
  .sd-btn:disabled { opacity: 0.35; cursor: not-allowed; }

  .sd-mode-toggle { display: flex; border: 1.5px solid #ccc; border-radius: 999px; overflow: hidden; width: fit-content; }
  .sd-mode-btn { padding: 0.22rem 0.8rem; font-size: 0.7rem; font-weight: 600; border: none; cursor: pointer; background: #fff; color: #666; transition: all 0.15s; }
  .sd-mode-btn.active { background: #000; color: #fff; }

  .sd-fields-row { display: flex; gap: 8px; align-items: flex-end; flex-wrap: wrap; }
  .sd-field-item { display: flex; flex-direction: column; flex: 1; min-width: 140px; border: none; padding: 0; background: transparent; }
  .sd-field-item .sd-label { color: #3b6fd4; margin-bottom: 4px; display: block; }
  .sd-field-btns { flex: 0 0 auto; display: flex; align-items: flex-end; gap: 6px; }

  .sd-badge { display: inline-flex; align-items: center; padding: 0.1rem 0.42rem; border-radius: 999px; font-size: 0.58rem; font-weight: 700; letter-spacing: 0.04em; }
  .sd-badge-loading { background: #fef9c3; color: #854d0e; }
  .sd-badge-ready   { background: #dcfce7; color: #166534; }
  .sd-badge-error   { background: #fee2e2; color: #991b1b; }
  .sd-badge-count   { background: #e0e7ff; color: #3730a3; margin-left: 0.22rem; }
  .sd-badge-new     { background: #f0fdf4; color: #16a34a; border: 1px solid #bbf7d0; margin-left: 0.18rem; font-size: 0.56rem; }

  .sd-react-select .react-select__control { border: 1.5px solid #ccc !important; border-radius: 999px !important; background: #fff !important; min-height: 28px !important; height: 28px !important; box-shadow: none !important; font-size: 0.78rem; flex-wrap: nowrap; }
  .sd-react-select .react-select__control--is-focused { border-color: #4f6ef7 !important; box-shadow: 0 0 0 2px rgba(79,110,247,0.1) !important; }
  .sd-react-select .react-select__menu { font-size: 0.78rem; border-radius: 12px; border: 1.5px solid #d8d8d8; box-shadow: 0 4px 20px rgba(0,0,0,0.12); }
  .sd-react-select .react-select__menu-list { padding: 4px; max-height: 200px; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #ccc transparent; }
  .sd-react-select .react-select__menu-list::-webkit-scrollbar { width: 5px; }
  .sd-react-select .react-select__menu-list::-webkit-scrollbar-thumb { background: #ccc; border-radius: 3px; }
  .sd-react-select .react-select__value-container { padding: 0 0.55rem; flex-wrap: nowrap; overflow: hidden; }
  .sd-react-select .react-select__indicator { padding: 0 5px; color: #666; }
  .sd-react-select .react-select__indicator-separator { display: none; }
  .sd-react-select .react-select__single-value { font-size: 0.78rem; color: #111; font-weight: 500; }
  .sd-react-select .react-select__placeholder { font-size: 0.75rem; color: #aaa; }
  .sd-react-select .react-select__option { font-size: 0.78rem; color: #111; padding: 6px 10px; border-radius: 6px; cursor: pointer; }
  .sd-react-select .react-select__option--is-selected { background: #111; color: #fff; }
  .sd-react-select .react-select__option--is-focused:not(.react-select__option--is-selected) { background: #f0f0f0; }
  .sd-react-select .react-select__input-container { margin: 0; padding: 0; }
  .sd-table .sd-react-select .react-select__control { min-height: 24px !important; height: 24px !important; }
  .sd-table .sd-react-select .react-select__value-container { height: 24px; }
  .sd-table .sd-react-select .react-select__indicators { height: 24px; }
  .sd-table .sd-input { height: 24px; padding: 0.14rem 0.5rem; font-size: 0.74rem; }

  .sd-table-wrap { overflow-x: auto; overflow-y: auto; border-radius: 12px; border: 1.5px solid #e0e0e0; max-height: 58vh; scrollbar-width: thin; scrollbar-color: #d0d0d0 transparent; }
  .sd-table-wrap::-webkit-scrollbar { width: 6px; height: 6px; }
  .sd-table-wrap::-webkit-scrollbar-thumb { background: #d0d0d0; border-radius: 4px; }
  .sd-table { width: 100%; border-collapse: collapse; font-size: 0.78rem; }
  .sd-table th { background: #f4f4f6; font-weight: 700; font-size: 0.6rem; letter-spacing: 0.06em; text-transform: uppercase; color: #3b6fd4; padding: 0.42rem 0.6rem; text-align: left; white-space: nowrap; border-bottom: 1.5px solid #e0e0e0; position: sticky; top: 0; z-index: 2; }
  .sd-table td { padding: 0.32rem 0.6rem; border-bottom: 1px solid #f0f0f0; vertical-align: top; color: #111; }
  .sd-table tr:last-child td { border-bottom: none; }
  .sd-table tr:hover td { background: #fafafa; }
  .sd-new-row td { background: #f0fdf4; }
  .sd-col-name-wrap { display: flex; align-items: center; gap: 0.2rem; }
  .sd-col-name-static { font-weight: 600; font-size: 0.78rem; flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 120px; color: #111; }
  .sd-col-rename-btn { background: none; border: none; cursor: pointer; color: #bbb; font-size: 0.65rem; padding: 0.08rem; line-height: 1; transition: color 0.15s; flex-shrink: 0; }
  .sd-col-rename-btn:hover { color: #4f6ef7; }
  .sd-delete-col-btn { background: none; border: none; cursor: pointer; color: #ccc; font-size: 0.9rem; padding: 0.08rem 0.22rem; border-radius: 999px; transition: color 0.15s; line-height: 1; }
  .sd-delete-col-btn:hover { color: #dc2626; }
  .sd-checkbox { width: 13px; height: 13px; accent-color: #1a1a18; cursor: pointer; }
  .sd-check-row { display: flex; align-items: center; gap: 0.4rem; font-size: 0.78rem; cursor: pointer; padding: 0.22rem 0; color: #000; }

  .sd-card-consolidated {
    background: #fffbf5;
    border: 1.5px solid #f5c97a;
    border-radius: 18px;
    padding: 0.8rem 1rem;
    margin-bottom: 0.55rem;
    position: relative;
  }
  .sd-card-consolidated::before {
    content: '';
    position: absolute;
    left: 0; top: 0; bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, #f59e0b, #d97706);
    border-radius: 18px 0 0 18px;
  }
  .ct-panel { padding-left: 4px; }
  .ct-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.6rem; }
  .ct-header-left { display: flex; align-items: center; gap: 0.6rem; }
  .ct-title { font-size: 0.6rem; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: #92400e; }
  .ct-scope-badge { font-size: 0.58rem; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; color: #b45309; background: #fef3c7; border: 1px solid #fcd34d; border-radius: 6px; padding: 0.13rem 0.45rem; }
  .ct-desc { font-size: 0.72rem; color: #92400e; opacity: 0.75; }
  .ct-entries { display: flex; flex-direction: column; gap: 0.3rem; margin-bottom: 0.55rem; }
  .ct-entry { display: flex; align-items: stretch; border: 1.5px solid #fcd34d; border-radius: 12px; overflow: hidden; background: #fff; }
  .ct-entry-label { background: #fef3c7; padding: 0.48rem 0.75rem; font-size: 0.72rem; font-weight: 700; color: #92400e; border-right: 1.5px solid #fcd34d; min-width: 150px; display: flex; align-items: center; gap: 0.35rem; white-space: nowrap; }
  .ct-entry-body { flex: 1; padding: 0.48rem 0.75rem; display: flex; align-items: center; gap: 0.5rem; }
  .ct-entry-actions { display: flex; align-items: center; padding: 0.48rem 0.55rem; border-left: 1px solid #fde68a; }
  .ct-empty { color: #c4924a; font-size: 0.74rem; font-style: italic; padding: 0.15rem 0; margin-bottom: 0.4rem; }
  .ct-add-wrap { display: flex; align-items: center; gap: 0.5rem; }

  .tc-wrap { display: flex; flex-direction: column; gap: 0.28rem; min-width: 175px; padding: 2px 0; }
  .tc-list { display: flex; flex-direction: column; gap: 0.16rem; }
  .tc-item { display: flex; align-items: center; gap: 0.22rem; background: #eff6ff; border: 1px solid #93c5fd; border-radius: 999px; padding: 0.12rem 0.35rem 0.12rem 0.5rem; font-size: 0.66rem; font-weight: 600; color: #1d4ed8; cursor: pointer; transition: background 0.12s; }
  .tc-item:hover { background: #dbeafe; }
  .tc-item-unsaved { background: #f5f5f5; border-color: #d0d0d0; color: #999; }
  .tc-item-label { flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 125px; }
  .tc-item-del { background: none; border: none; color: #93c5fd; cursor: pointer; font-size: 0.7rem; line-height: 1; padding: 0 0.06rem; flex-shrink: 0; transition: color 0.12s; }
  .tc-item-del:hover { color: #dc2626; }

  .sd-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.28); display: flex; align-items: center; justify-content: center; z-index: 9000; }
  .sd-modal { background: #fff; border-radius: 18px; padding: 0; width: 560px; max-width: 96vw; max-height: 84vh; display: flex; flex-direction: column; box-shadow: 0 12px 60px rgba(0,0,0,0.18); overflow: hidden; }
  .sd-modal-lg  { width: 760px; }
  .sd-modal-xl  { width: 920px; }
  .sd-modal-header { display: flex; justify-content: space-between; align-items: center; padding: 0.85rem 1.1rem 0.7rem; flex-shrink: 0; border-bottom: 1.5px solid #f0f0f0; }
  .sd-modal-title { font-size: 0.88rem; font-weight: 700; }
  .sd-modal-close { background: none; border: none; font-size: 1rem; cursor: pointer; color: #999; line-height: 1; }
  .sd-modal-close:hover { color: #333; }
  .sd-modal-body { flex: 1; overflow-y: auto; overflow-x: hidden; padding: 0.9rem 1.1rem; scrollbar-width: thin; scrollbar-color: #d0d0d0 transparent; }
  .sd-modal-body::-webkit-scrollbar { width: 5px; }
  .sd-modal-body::-webkit-scrollbar-thumb { background: #d0d0d0; border-radius: 4px; }
  .sd-modal-footer { display: flex; align-items: center; gap: 0.4rem; justify-content: flex-end; flex-shrink: 0; padding: 0.65rem 1.1rem; border-top: 1px solid #f0f0f0; }

  .sd-val-layout { display: flex; gap: 1.2rem; }
  .sd-val-checks { flex: 1; }
  .sd-val-inputs { flex: 1; display: flex; flex-direction: column; gap: 0.4rem; background: #f8f8f8; padding: 0.7rem; border-radius: 12px; border: 1px solid #efefef; }
  .sd-section-title { font-size: 0.58rem; font-weight: 700; letter-spacing: 0.10em; text-transform: uppercase; color: #888; margin: 0.6rem 0 0.35rem; }
  .sd-grid { display: grid; gap: 0.45rem; }
  .sd-grid-2 { grid-template-columns: 1fr 1fr; }
  hr.sd-hr { border: none; border-top: 1px solid #f0f0f0; margin: 0.5rem 0; }

  .fc-row { display: flex; align-items: flex-end; gap: 0.45rem; flex-wrap: wrap; padding: 0.5rem 0; border-bottom: 1px solid #f2f2f2; }
  .fc-row:last-of-type { border-bottom: none; padding-bottom: 0; }
  .fc-field { display: flex; flex-direction: column; gap: 0.18rem; flex: 1; min-width: 110px; }
  .fc-field-sm { flex: 0 0 82px; min-width: 0; }
  .fc-label { font-size: 0.58rem; font-weight: 700; color: #555; letter-spacing: 0.06em; text-transform: uppercase; white-space: nowrap; }
  .fc-row-del { flex-shrink: 0; align-self: flex-end; margin-bottom: 2px; background: none; border: none; width: 22px; height: 22px; display: flex; align-items: center; justify-content: center; font-size: 0.7rem; color: #ccc; cursor: pointer; transition: color 0.12s; border-radius: 50%; }
  .fc-row-del:hover { color: #dc2626; background: #fee2e2; }
  .fc-add-btn { width: 100%; margin-top: 0.5rem; background: #f8f8f8; border: 1.5px dashed #d0d0d0; border-radius: 10px; padding: 0.3rem; font-size: 0.7rem; font-weight: 600; color: #888; cursor: pointer; transition: all 0.15s; display: flex; align-items: center; justify-content: center; gap: 0.3rem; }
  .fc-add-btn:hover { background: #f0fdf4; border-color: #86efac; color: #16a34a; }

  .scope-hint { display: inline-flex; align-items: center; gap: 0.3rem; background: #f0f4ff; border: 1px solid #c7d6ff; border-radius: 8px; padding: 0.3rem 0.65rem; font-size: 0.72rem; color: #2d4fa3; font-weight: 600; margin-bottom: 0.75rem; }
  .scope-hint.global { background: #fff7ed; border-color: #fed7aa; color: #c05800; }
`;

// --- Shared primitives --------------------------------------------------------

const PORTAL_STYLES = { menuPortal: b => ({ ...b, zIndex: 99999 }) };

function PillSelect({ options, value, onChange, placeholder, isDisabled, usePortal }) {
  return (
    <Select options={options} value={value} onChange={onChange}
      placeholder={placeholder || "Select"}
      classNamePrefix="react-select" className="sd-react-select"
      menuPortalTarget={usePortal ? document.body : null}
      menuPlacement="auto"
      menuPosition={usePortal ? "fixed" : "absolute"}
      styles={
        usePortal ? PORTAL_STYLES : undefined} isDisabled={isDisabled} />
  );
}

function FcField({ label, children, sm }) {
  return (
    <div className={`fc-field${sm ? " fc-field-sm" : ""}`}>
      {label && <label className="fc-label">{label}</label>}
      {children}
    </div>
  );
}
function FcInput({ value, onChange, placeholder, type }) {
  return (
    <input className="sd-input" type={type || "text"} value={value || ""}
      onChange={e => onChange(e.target.value)} placeholder={placeholder || ""} style={{ height: 28 }} />
  );
}

function ScopeHint({ label, global }) {
  return (
    <div className={`scope-hint${global ? " global" : ""}`}>
      <span>{global ? "*" : ">"}</span>
      <span>{label}</span>
    </div>
  );
}

// minRows=0  every row deletable
function FcRowContainer({ rows, setRows, mkEmpty, renderRow }) {
  const upd = (i, f, v) => setRows(p => p.map((r, ri) => ri !== i ? r : { ...r, [f]: v }));
  const del = i => setRows(p => p.filter((_, ri) => ri !== i));
  const add = () => setRows(p => [...p, mkEmpty()]);
  return (
    <div>
      {rows.length === 0 && (
        <div style={{ color: "#aaa", fontSize: "0.75rem", fontStyle: "italic", padding: "0.4rem 0 0.6rem" }}>
          No rows yet. Click "+ Add Row" to begin.
        </div>
      )}
      {rows.map((row, i) => (
        <div key={i} className="fc-row">
          {renderRow(row, i, (f, v) => upd(i, f, v))}
          <button className="fc-row-del" onClick={() => del(i)} title="Delete this row">x</button>
        </div>
      ))}
      <button className="fc-add-btn" onClick={add}>+ Add Row</button>
    </div>
  );
}

// --- CONSOLIDATED MODALS -----------------------------------------------------
// Props: savedData (snapshot at open), onSave(newData), onCancel, allColumns

const mkDupRow = () => ({
  column: null,
  mode: null,
  db: null,
  schema: null,
  table: null,
  dbColumn: null
});
const mkDropRow = () => ({ action: null, rowIndex: "", value: "", column: null, dropCondition: null, columnIndex: "", deleteCondition: null, deleteRowIndex: "" });
const mkKeepRow = () => ({ column: null, mode: null, schema: null, table: null, dbColumn: null });

function DuplicateCheckModal({ savedData, onSave, onCancel, allColumns }) {
  const colOpts = allColumns.map(c => ({ value: c, label: c }));

  const mkRow = () => ({
    column: null,
    mode: null,
    schema: null,
    table: null,
    dbColumn: null,
    schemaOptions: [],
    tableOptions: [],
    columnOptions: []
  });

  const [rows, setRows] = useState(
    savedData?.dupCheck?.length
      ? savedData.dupCheck.map(r => ({ ...mkRow(), ...r }))
      : [mkRow()]
  );

  // ------------------ FETCH FUNCTIONS ------------------

  const fetchSchemas = async (index) => {
    try {
      const creds = Fetchexecutequery();

      const res = await axios.post(
        creds[1],
        { query: `show databases` },
        creds[0]
      );

      const options = res.data.map(d => ({
        value: d.Database,
        label: d.Database
      }));

      setRows(prev => {
        const updated = [...prev];
        updated[index].schemaOptions = options;
        updated[index].tableOptions = [];
        updated[index].columnOptions = [];
        return updated;
      });
    } catch (err) {
      console.error("Schema fetch error", err);
    }
  };

  const fetchTables = async (schema, index) => {
    try {
      const creds = Fetchexecutequery();

      const res = await axios.post(
        creds[1],
        { query: `show tables from ${schema.value}` },
        creds[0]
      );

      const key = Object.keys(res.data[0] || {})[0];

      const options = res.data.map(t => ({
        value: t[key],
        label: t[key]
      }));

      setRows(prev => {
        const updated = [...prev];
        updated[index].tableOptions = options;
        updated[index].columnOptions = [];
        return updated;
      });
    } catch (err) {
      console.error("Table fetch error", err);
    }
  };

  const fetchColumns = async (schema, table, index) => {
    try {
      const creds = Fetchexecutequery();

      const res = await axios.post(
        creds[1],
        { query: `desc ${schema.value}.${table.value}` },
        creds[0]
      );

      const options = res.data.map(c => ({
        value: c.Field,
        label: c.Field
      }));

      setRows(prev => {
        const updated = [...prev];
        updated[index].columnOptions = options;
        return updated;
      });
    } catch (err) {
      console.error("Column fetch error", err);
    }
  };

  // ------------------ UI ------------------

  const updateRow = (i, field, value) => {
    setRows(prev => {
      const updated = [...prev];
      updated[i][field] = value;
      return updated;
    });
  };

  return (
    <div className="sd-overlay" onClick={onCancel}>
      <div className="sd-modal sd-modal-lg" onClick={e => e.stopPropagation()}>
        <div className="sd-modal-header">
          <span className="sd-modal-title">Duplicate Check</span>
          <button className="sd-modal-close" onClick={onCancel}>x</button>
        </div>

        <div className="sd-modal-body">
          <FcRowContainer
            rows={rows}
            setRows={setRows}
            mkEmpty={mkRow}
            renderRow={(row, i) => (
              <>
                {/* Column */}
                <FcField label="Column">
                  <PillSelect
                    options={colOpts}
                    value={colOpts.find(o => o.value === row.column) || null}
                    onChange={o => updateRow(i, "column", o?.value)}
                  />
                </FcField>

                {/* Mode */}
                <FcField label="Mode">
                  <PillSelect
                    options={SRC_DB_OPTS}
                    value={row.mode}
                    onChange={v => {
                      updateRow(i, "mode", v);
                      if (v?.value === "database") fetchSchemas(i);
                    }}
                  />
                </FcField>

                {/* DATABASE FLOW */}
                {row.mode?.value === "database" && (
                  <>
                    {/* Schema */}
                    <FcField label="Schema">
                      <PillSelect
                        options={row.schemaOptions}
                        value={row.schema}
                        onChange={v => {
                          updateRow(i, "schema", v);
                          fetchTables(v, i);
                        }}
                      />
                    </FcField>

                    {/* Table */}
                    <FcField label="Table">
                      <PillSelect
                        options={row.tableOptions}
                        value={row.table}
                        onChange={v => {
                          updateRow(i, "table", v);
                          fetchColumns(row.schema, v, i);
                        }}
                      />
                    </FcField>

                    {/* Column */}
                    <FcField label="DB Column">
                      <PillSelect
                        options={row.columnOptions}
                        value={row.dbColumn}
                        onChange={v => updateRow(i, "dbColumn", v)}
                      />
                    </FcField>
                  </>
                )}
              </>
            )}
          />
        </div>

        <div className="sd-modal-footer">
          <button className="sd-btn sd-btn-secondary" onClick={onCancel}>Cancel</button>
          <button
            className="sd-btn sd-btn-success"
            onClick={() => onSave({ dupCheck: rows })}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

function DropRowsModal({ savedData, onSave, onCancel, allColumns }) {
  const colOpts = allColumns.map(c => ({ value: c, label: c }));
  const [rows, setRows] = useState(savedData?.drop?.length ? savedData.drop : [mkDropRow()]);
  return (
    <div className="sd-overlay" onClick={onCancel}>
      <div className="sd-modal sd-modal-lg" onClick={e => e.stopPropagation()}>
        <div className="sd-modal-header">
          <span className="sd-modal-title">Drop Rows / Columns</span>
          <button className="sd-modal-close" onClick={onCancel}>x</button>
        </div>
        <div className="sd-modal-body">
          <ScopeHint global label="File-level  applies across the whole source" />
          <FcRowContainer rows={rows} setRows={setRows} mkEmpty={mkDropRow} renderRow={(row, i, upd) => (<>
            <FcField label="Action">
              <PillSelect options={DROP_OPTS} value={row.action} onChange={v => upd("action", v)} />
            </FcField>
            {row.action?.value === "index" && (
              <FcField label="Row Index" sm><FcInput type="number" value={row.rowIndex} onChange={v => upd("rowIndex", v)} placeholder="0" /></FcField>
            )}
            {row.action?.value === "value" && (<>
              <FcField label="Column"><PillSelect options={colOpts} value={colOpts.find(o => o.value === row.column) || null} onChange={o => upd("column", o?.value)} /></FcField>
              <FcField label="Value to Match"><FcInput value={row.value} onChange={v => upd("value", v)} placeholder="Value to drop" /></FcField>
            </>)}
            {row.action?.value === "after_empty_cell" && (
              <FcField label="Column"><PillSelect options={colOpts} value={colOpts.find(o => o.value === row.column) || null} onChange={o => upd("column", o?.value)} /></FcField>
            )}
            {row.action?.value === "drop_columns" && (<>
              <FcField label="Select By"><PillSelect options={DROPCOND_OPTS} value={row.dropCondition} onChange={v => upd("dropCondition", v)} /></FcField>
              {row.dropCondition?.value === "column_name" && <FcField label="Column"><PillSelect options={colOpts} value={colOpts.find(o => o.value === row.column) || null} onChange={o => upd("column", o?.value)} /></FcField>}
              {row.dropCondition?.value === "column_index" && <FcField label="Column Index" sm><FcInput type="number" value={row.columnIndex} onChange={v => upd("columnIndex", v)} placeholder="0" /></FcField>}
            </>)}
            {row.action?.value === "delete_rows" && (<>
              <FcField label="Column"><PillSelect options={colOpts} value={colOpts.find(o => o.value === row.column) || null} onChange={o => upd("column", o?.value)} /></FcField>
              <FcField label="Condition"><PillSelect options={DELCOND_OPTS} value={row.deleteCondition} onChange={v => upd("deleteCondition", v)} /></FcField>
              {row.deleteCondition?.value === "index" && <FcField label="Row Index" sm><FcInput type="number" value={row.deleteRowIndex} onChange={v => upd("deleteRowIndex", v)} placeholder="0" /></FcField>}
            </>)}
          </>)} />
        </div>
        <div className="sd-modal-footer">
          <button className="sd-btn sd-btn-secondary" onClick={onCancel}>Cancel</button>
          <button className="sd-btn sd-btn-success" onClick={() => onSave({ drop: rows })}>Save</button>
        </div>
      </div>
    </div>
  );
}

function KeepColumnsModal({ savedData, onSave, onCancel, allColumns }) {
  const colOpts = allColumns.map(c => ({ value: c, label: c }));

  const mkRow = () => ({
    column: null,
    mode: null,
    db: null,
    schema: null,
    table: null,
    dbColumn: null,
    schemaOptions: [],
    tableOptions: [],
    columnOptions: []
  });

  const [rows, setRows] = useState(
    savedData?.keepCols?.length
      ? savedData.keepCols.map(r => ({ ...mkRow(), ...r }))
      : [mkRow()]
  );

  // ---------------- FETCH FUNCTIONS ----------------

  const fetchSchemas = async (index) => {
    try {
      const creds = Fetchexecutequery();

      const res = await axios.post(
        creds[1],
        { query: `show databases` },
        creds[0]
      );

      const options = res.data.map(d => ({
        value: d.Database,
        label: d.Database
      }));

      setRows(prev => {
        const updated = [...prev];
        updated[index].schemaOptions = options;
        updated[index].tableOptions = [];
        updated[index].columnOptions = [];
        return updated;
      });
    } catch (err) {
      console.error("Schema fetch error", err);
    }
  };

  const fetchTables = async (schema, index) => {
    try {
      const creds = Fetchexecutequery();

      const res = await axios.post(
        creds[1],
        { query: `show tables from ${schema.value}` },
        creds[0]
      );

      const key = Object.keys(res.data[0] || {})[0];

      const options = res.data.map(t => ({
        value: t[key],
        label: t[key]
      }));

      setRows(prev => {
        const updated = [...prev];
        updated[index].tableOptions = options;
        updated[index].columnOptions = [];
        return updated;
      });
    } catch (err) {
      console.error("Table fetch error", err);
    }
  };

  const fetchColumns = async (schema, table, index) => {
    try {
      const creds = Fetchexecutequery();

      const res = await axios.post(
        creds[1],
        { query: `desc ${schema.value}.${table.value}` },
        creds[0]
      );

      const options = res.data.map(c => ({
        value: c.Field,
        label: c.Field
      }));

      setRows(prev => {
        const updated = [...prev];
        updated[index].columnOptions = options;
        return updated;
      });
    } catch (err) {
      console.error("Column fetch error", err);
    }
  };

  const updateRow = (i, field, value) => {
    setRows(prev => {
      const updated = [...prev];
      updated[i][field] = value;
      return updated;
    });
  };

  // ---------------- UI ----------------

  return (
    <div className="sd-overlay" onClick={onCancel}>
      <div className="sd-modal sd-modal-lg" onClick={e => e.stopPropagation()}>
        <div className="sd-modal-header">
          <span className="sd-modal-title">Keep Columns</span>
          <button className="sd-modal-close" onClick={onCancel}>x</button>
        </div>

        <div className="sd-modal-body">
          <ScopeHint global label="File-level defines which columns survive in the output" />

          <FcRowContainer
            rows={rows}
            setRows={setRows}
            mkEmpty={mkRow}
            renderRow={(row, i) => (
              <>
                {/* Column */}
                <FcField label="Column to Keep">
                  <PillSelect
                    options={colOpts}
                    value={colOpts.find(o => o.value === row.column) || null}
                    onChange={o => updateRow(i, "column", o?.value)}
                  />
                </FcField>

                {/* Mode */}
                <FcField label="Columns From">
                  <PillSelect
                    options={SRC_DB_OPTS}
                    value={row.mode}
                    onChange={v => {
                      updateRow(i, "mode", v);
                      if (v?.value === "database") fetchSchemas(i);
                    }}
                  />
                </FcField>

                {row.mode?.value === "database" && (
                  <>
                    {/* Schema */}
                    <FcField label="Schema">
                      <PillSelect
                        options={row.schemaOptions}
                        value={row.schema}
                        onChange={v => {
                          updateRow(i, "schema", v);
                          fetchTables(v, i);
                        }}
                      />
                    </FcField>

                    {/* Table */}
                    <FcField label="Table">
                      <PillSelect
                        options={row.tableOptions}
                        value={row.table}
                        onChange={v => {
                          updateRow(i, "table", v);
                          fetchColumns(row.schema, v, i);
                        }}
                      />
                    </FcField>

                    {/* Column */}
                    <FcField label="DB Column">
                      <PillSelect
                        options={row.columnOptions}
                        value={row.dbColumn}
                        onChange={v => updateRow(i, "dbColumn", v)}
                      />
                    </FcField>
                  </>
                )}
              </>
            )}
          />
        </div>

        <div className="sd-modal-footer">
          <button className="sd-btn sd-btn-secondary" onClick={onCancel}>Cancel</button>
          <button
            className="sd-btn sd-btn-success"
            onClick={() => onSave({ keepCols: rows })}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

// -- Consolidated Transform Panel --
const CONSOLIDATED_MODAL_MAP = {
  "Duplicate Check": DuplicateCheckModal,
  "Drop Rows/Columns": DropRowsModal,
  "Keep Columns": KeepColumnsModal,
};

function ConsolidatedTransformPanel({ consolidatedData, updateConsolidatedData, allColumns }) {
  const [entries, setEntries] = useState(consolidatedData._entries || []);
  const [openId, setOpenId] = useState(null);
  const [addSel, setAddSel] = useState(null);
  const idRef = useRef(0);

  useEffect(() => {
    const savedEntries = consolidatedData._entries || [];
    setEntries(savedEntries);
    idRef.current = savedEntries.reduce((max, entry) => Math.max(max, Number(entry.id) || 0), 0);
  }, [consolidatedData]);

  const handleAdd = opt => {
    if (!opt) return;
    setAddSel(null);
    const existing = entries.find(e => e.type === opt.value);
    if (existing) { setOpenId(existing.id); return; }
    const id = ++idRef.current;
    const nextEntries = [...entries, { id, type: opt.value, label: opt.label, saved: false }];
    setEntries(nextEntries);
    updateConsolidatedData({ ...consolidatedData, _entries: nextEntries });
    setOpenId(id);
  };

  const handleSave = (id, newData) => {
    const entryKey = `entry_${id}`;
    const nextEntries = entries.map(e => e.id === id ? { ...e, saved: true } : e);
    updateConsolidatedData({
      ...consolidatedData,
      _entries: nextEntries,
      [entryKey]: { ...(consolidatedData[entryKey] || {}), ...newData },
    });
    setEntries(nextEntries);
    setOpenId(null);
  };

  const handleCancel = id => {
    const entry = entries.find(e => e.id === id);
    if (entry && !entry.saved) {
      const nextEntries = entries.filter(e => e.id !== id);
      setEntries(nextEntries);
      const newData = { ...consolidatedData };
      delete newData[`entry_${id}`];
      newData._entries = nextEntries;
      updateConsolidatedData(newData);
    }
    setOpenId(null);
  };

  const handleRemove = id => {
    const nextEntries = entries.filter(e => e.id !== id);
    setEntries(nextEntries);
    const newData = { ...consolidatedData };
    delete newData[`entry_${id}`];
    newData._entries = nextEntries;
    updateConsolidatedData(newData);
  };

  const openEntry = entries.find(e => e.id === openId);

  const renderModal = () => {
    if (!openEntry) return null;
    const Modal = CONSOLIDATED_MODAL_MAP[openEntry.type];
    if (!Modal) return null;
    const savedData = consolidatedData[`entry_${openEntry.id}`] || {};
    return (
      <Modal
        savedData={savedData}
        onSave={newData => handleSave(openEntry.id, newData)}
        onCancel={() => handleCancel(openEntry.id)}
        allColumns={allColumns}
      />
    );
  };

  const rowCountFor = id => {
    const d = consolidatedData[`entry_${id}`] || {};
    return [d.dupCheck, d.drop, d.keepCols].filter(Boolean).reduce((s, a) => s + a.length, 0);
  };

  const ICONS = { "Duplicate Check": "D", "Drop Rows/Columns": "X", "Keep Columns": "K" };
  const availableOpts = CONSOLIDATED_TRANSFORM_OPTIONS.filter(o => !entries.find(e => e.type === o.value));

  return (
    <div className="ct-panel">
      <div className="ct-header">
        <div className="ct-header-left">
          <span className="ct-title">Consolidated Transforms</span>
          <span className="ct-scope-badge">File-level</span>
          <span className="ct-desc">Applied to the entire source before column processing</span>
        </div>
      </div>

      {entries.length > 0 && (
        <div className="ct-entries">
          {entries.map(e => {
            const count = rowCountFor(e.id);
            return (
              <div key={e.id} className="ct-entry">
                <div className="ct-entry-label">
                  <span>{ICONS[e.type] || "*"}</span>
                  {e.label}
                  {e.saved && count > 0 && <span className="sd-badge" style={{ background: "#fef3c7", color: "#92400e", border: "1px solid #fcd34d", marginLeft: 6 }}>{count} row{count > 1 ? "s" : ""}</span>}
                  {!e.saved && <span className="sd-badge" style={{ background: "#f0f0f0", color: "#999", border: "1px solid #ddd", marginLeft: 6 }}>unsaved</span>}
                </div>
                <div className="ct-entry-body">
                  <button className="sd-btn sd-btn-sm" style={{ background: "#fef3c7", color: "#92400e", border: "1.5px solid #fcd34d" }} onClick={() => setOpenId(e.id)}>
                    Configure
                  </button>
                </div>
                <div className="ct-entry-actions">
                  <button className="sd-delete-col-btn" title="Remove" onClick={() => handleRemove(e.id)}></button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {entries.length === 0 && (
        <p className="ct-empty">No file-level transforms added yet.</p>
      )}

      {availableOpts.length > 0 && (
        <div className="ct-add-wrap" style={{ marginTop: entries.length > 0 ? "0.55rem" : "0.35rem" }}>
          <div style={{ width: 240 }}>
            <PillSelect options={availableOpts} value={addSel} onChange={handleAdd} placeholder="+ Add file-level transform"
              usePortal={true} />
          </div>
        </div>
      )}

      {renderModal()}
    </div>
  );
}

// --- COLUMN-LEVEL MODALS ------------------------------------------------------
// All column modals: props = { colName, data, setData, onClose, onSaved, [allColumns] }
// onClose = cancel; if unsaved, the pill is removed by TransformCell.
// onSaved is called after setData on save and marks the pill as saved.

function ValidationModal({
  colName,
  validationDatatype,
  setValidationDatatype,
  mandataryData,
  setMandataryData,
  onClose,
}) {
  const existing = validationDatatype.filter(v => v[colName] !== undefined);

  // =========================
  // ROW FACTORY
  // =========================
  const mkRow = () => ({
    db: null,
    schema: null,
    table: null,
    column: null,
    schemaOptions: [],
    tableOptions: [],
    columnOptions: [],
  });

  const [rows, setRows] = useState(existing.length ? existing : [mkRow()]);

  // =========================
  // UPDATE ROW
  // =========================
  const updateRow = (i, key, value) => {
    setRows(prev => {
      const updated = [...prev];
      updated[i][key] = value;
      return updated;
    });
  };

  // =========================
  // FETCH LOGIC (LIKE YOUR MAIN FILE)
  // =========================
  const fetchSchemas = async (db, i) => {
    const res = await axios.post("/api/query", {
      query: `show databases`,
    });

    const opts = res.data.map(d => ({
      value: d.Database,
      label: d.Database,
    }));

    setRows(prev => {
      const updated = [...prev];
      updated[i].schemaOptions = opts;
      updated[i].tableOptions = [];
      updated[i].columnOptions = [];
      return updated;
    });
  };

  const fetchTables = async (schema, i) => {
    const res = await axios.post("/api/query", {
      query: `show tables from ${schema.value}`,
    });

    const key = Object.keys(res.data[0])[0];

    const opts = res.data.map(t => ({
      value: t[key],
      label: t[key],
    }));

    setRows(prev => {
      const updated = [...prev];
      updated[i].tableOptions = opts;
      updated[i].columnOptions = [];
      return updated;
    });
  };

  const fetchColumns = async (schema, table, i) => {
    const res = await axios.post("/api/query", {
      query: `desc ${schema.value}.${table.value}`,
    });

    const opts = res.data.map(c => ({
      value: c.Field,
      label: c.Field,
    }));

    setRows(prev => {
      const updated = [...prev];
      updated[i].columnOptions = opts;
      return updated;
    });
  };

  // =========================
  // SAVE
  // =========================
  const handleSave = () => {
    const newValidations = rows.map(r => ({
      [colName]: {
        db: r.db?.value,
        schema: r.schema?.value,
        table: r.table?.value,
        column: r.column?.value,
      },
    }));

    setValidationDatatype(prev => [
      ...prev.filter(v => v[colName] === undefined),
      ...newValidations,
    ]);

    onClose();
  };

  // =========================
  // UI
  // =========================
  return (
    <div className="sd-overlay" onClick={onClose}>
      <div className="sd-modal" onClick={e => e.stopPropagation()}>

        <div className="sd-modal-header">
          <span className="sd-modal-title">Validation (DB Mapping)</span>
        </div>

        <div className="sd-modal-body">

          {rows.map((row, i) => (
            <div key={i} className="fc-row">

              {/* DB */}
              <FcField label="DB">
                <PillSelect
                  options={[{ value: "mysql", label: "MySQL" }]}
                  value={row.db}
                  onChange={v => {
                    updateRow(i, "db", v);
                    fetchSchemas(v, i);
                  }}
                />
              </FcField>

              {/* SCHEMA */}
              <FcField label="Schema">
                <PillSelect
                  options={row.schemaOptions}
                  value={row.schema}
                  onChange={v => {
                    updateRow(i, "schema", v);
                    fetchTables(v, i);
                  }}
                />
              </FcField>

              {/* TABLE */}
              <FcField label="Table">
                <PillSelect
                  options={row.tableOptions}
                  value={row.table}
                  onChange={v => {
                    updateRow(i, "table", v);
                    fetchColumns(row.schema, v, i);
                  }}
                />
              </FcField>

              {/* COLUMN */}
              <FcField label="Column">
                <PillSelect
                  options={row.columnOptions}
                  value={row.column}
                  onChange={v => updateRow(i, "column", v)}
                />
              </FcField>

            </div>
          ))}

          <button className="fc-add-btn" onClick={() => setRows(p => [...p, mkRow()])}>
            + Add Row
          </button>

        </div>

        <div className="sd-modal-footer">
          <button className="sd-btn sd-btn-secondary" onClick={onClose}>Cancel</button>
          <button className="sd-btn sd-btn-success" onClick={handleSave}>Save</button>
        </div>

      </div>
    </div>
  );
}
function ChangeDateFormatModal({ colName, data, setData, onClose, onDismiss, onSaved }) {
  const dis = onDismiss || onClose;
  const saved = data.dateFormat || {};
  const [fromFmt, setFromFmt] = useState(DATE_FORMAT_OPTIONS.find(o => o.value === saved.from) || null);
  const [toFmt, setToFmt] = useState(DATE_FORMAT_OPTIONS.find(o => o.value === saved.to) || null);
  const save = () => { if (!fromFmt || !toFmt) { alert("Please select both formats"); return; } setData(p => ({ ...p, dateFormat: { from: fromFmt?.value, to: toFmt?.value } })); onSaved?.(); dis(); };
  return (
    <div className="sd-overlay" onClick={dis}>
      <div className="sd-modal" onClick={e => e.stopPropagation()}>
        <div className="sd-modal-header">
          <span className="sd-modal-title">Change Date Format</span>
          <button className="sd-modal-close" onClick={dis}>x</button>
        </div>
        <div className="sd-modal-body">
          <ScopeHint label={`Column: ${colName}`} />
          <div className="sd-grid sd-grid-2">
            <div className="sd-field"><label className="sd-label">From Format</label>
              <PillSelect options={DATE_FORMAT_OPTIONS} value={fromFmt} onChange={setFromFmt} placeholder="Current format" /></div>
            <div className="sd-field"><label className="sd-label">To Format</label>
              <PillSelect options={DATE_FORMAT_OPTIONS} value={toFmt} onChange={setToFmt} placeholder="Target format" /></div>
          </div>
        </div>
        <div className="sd-modal-footer">
          <button className="sd-btn sd-btn-secondary" onClick={onClose}>Cancel</button>
          <button className="sd-btn sd-btn-success" onClick={save}>Save</button>
        </div>
      </div>
    </div>
  );
}

function PositionModal({ colName, data, setData, onClose, onDismiss, onSaved }) {
  const dis = onDismiss || onClose;
  const saved = data.position || {};
  const [startRow, setStartRow] = useState(saved.startRow || "");
  const [endRow, setEndRow] = useState(saved.endRow || "");
  const save = () => { if (!startRow || !endRow) { alert("Please enter both start and end rows"); return; } if (parseInt(startRow, 10) >= parseInt(endRow, 10)) { alert("Start row must be less than end row"); return; } setData(p => ({ ...p, position: { startRow, endRow } })); onSaved?.(); dis(); };
  return (
    <div className="sd-overlay" onClick={dis}>
      <div className="sd-modal" onClick={e => e.stopPropagation()}>
        <div className="sd-modal-header">
          <span className="sd-modal-title">Position</span>
          <button className="sd-modal-close" onClick={dis}>x</button>
        </div>
        <div className="sd-modal-body">
          <ScopeHint label={`Column: ${colName}`} />
          <div className="sd-grid sd-grid-2">
            <div className="sd-field"><label className="sd-label">Start Row</label>
              <input className="sd-input" type="number" min="1" value={startRow} onChange={e => setStartRow(e.target.value)} placeholder="e.g. 1" /></div>
            <div className="sd-field"><label className="sd-label">End Row</label>
              <input className="sd-input" type="number" min="1" value={endRow} onChange={e => setEndRow(e.target.value)} placeholder="e.g. 100" /></div>
          </div>
        </div>
        <div className="sd-modal-footer">
          <button className="sd-btn sd-btn-secondary" onClick={onClose}>Cancel</button>
          <button className="sd-btn sd-btn-success" onClick={save}>Save</button>
        </div>
      </div>
    </div>
  );
}

function ChangeColumnNameModal({ colName, data, setData, onClose, onDismiss, onSaved }) {
  const dis = onDismiss || onClose;
  const [newName, setNewName] = useState(data.colRename || "");
  const save = () => { setData(p => ({ ...p, colRename: newName.trim() })); onSaved?.(); dis(); };
  return (
    <div className="sd-overlay" onClick={dis}>
      <div className="sd-modal" onClick={e => e.stopPropagation()}>
        <div className="sd-modal-header">
          <span className="sd-modal-title">Change Column Name</span>
          <button className="sd-modal-close" onClick={dis}>x</button>
        </div>
        <div className="sd-modal-body">
          <ScopeHint label={`Column: ${colName}`} />
          <div className="sd-field"><label className="sd-label">New Column Name</label>
            <input className="sd-input" value={newName} onChange={e => setNewName(e.target.value)} placeholder="Enter new name" autoFocus /></div>
        </div>
        <div className="sd-modal-footer">
          <button className="sd-btn sd-btn-secondary" onClick={onClose}>Cancel</button>
          <button className="sd-btn sd-btn-success" onClick={save} disabled={!newName.trim()}>Save</button>
        </div>
      </div>
    </div>
  );
}

const mkExtRow = () => ({ startPosition: "", identifierTypeStart: null, startIdentifier: "", length: "", endPosition: "", identifierTypeEnd: null, endIdentifier: "", extractionType: null, populationColumn: "" });

function FieldExtractionModal({ colName, data, setData, allColumns, onClose, onDismiss, onSaved }) {
  const dis = onDismiss || onClose;
  const colOpts = allColumns.map(c => ({ value: c, label: c }));
  const [rows, setRows] = useState(data.fieldExtraction?.length ? data.fieldExtraction : [mkExtRow()]);
  const save = () => { setData(p => ({ ...p, fieldExtraction: rows })); onSaved?.(); dis(); };
  return (
    <div className="sd-overlay" onClick={dis}>
      <div className="sd-modal sd-modal-xl" onClick={e => e.stopPropagation()}>
        <div className="sd-modal-header">
          <span className="sd-modal-title">Field Extraction</span>
          <button className="sd-modal-close" onClick={dis}>x</button>
        </div>
        <div className="sd-modal-body">
          <ScopeHint label={`Column: ${colName}`} />
          <FcRowContainer rows={rows} setRows={setRows} mkEmpty={mkExtRow} renderRow={(row, i, upd) => (<>
            <div style={{ width: "100%", display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: "0.4rem" }}>
              <FcField label="Start Position"><FcInput value={row.startPosition} onChange={v => upd("startPosition", v)} placeholder="0" /></FcField>
              <FcField label="Start Identifier"><FcInput value={row.startIdentifier} onChange={v => upd("startIdentifier", v)} placeholder="Delimiter" /></FcField>
              <FcField label="ID Type (Start)"><PillSelect options={IDENTIFIER_TYPE_OPTIONS} value={row.identifierTypeStart} onChange={v => upd("identifierTypeStart", v)} /></FcField>
              <FcField label="Length"><FcInput value={row.length} onChange={v => upd("length", v)} placeholder="chars" /></FcField>
            </div>
            <div style={{ width: "100%", display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: "0.4rem" }}>
              <FcField label="End Position"><FcInput value={row.endPosition} onChange={v => upd("endPosition", v)} placeholder="0" /></FcField>
              <FcField label="End Identifier"><FcInput value={row.endIdentifier} onChange={v => upd("endIdentifier", v)} placeholder="Delimiter" /></FcField>
              <FcField label="ID Type (End)"><PillSelect options={IDENTIFIER_TYPE_OPTIONS} value={row.identifierTypeEnd} onChange={v => upd("identifierTypeEnd", v)} /></FcField>
              <FcField label="Extraction Type"><PillSelect options={IDENTIFIER_TYPE_OPTIONS} value={row.extractionType} onChange={v => upd("extractionType", v)} /></FcField>
            </div>
            <div style={{ width: "100%", display: "grid", gridTemplateColumns: "1fr 3fr", gap: "0.4rem" }}>
              <FcField label="Write Into Column"><PillSelect options={colOpts} value={colOpts.find(o => o.value === row.populationColumn) || null} onChange={o => upd("populationColumn", o?.value || "")} placeholder="Target column" /></FcField>
            </div>
            <hr className="sd-hr" />
          </>)} />
        </div>
        <div className="sd-modal-footer">
          <button className="sd-btn sd-btn-secondary" onClick={onClose}>Cancel</button>
          <button className="sd-btn sd-btn-success" onClick={save}>Save</button>
        </div>
      </div>
    </div>
  );
}

const mkTxnRow = () => ({ startPosition: "", identifierTypeStart: null, startIdentifier: "", length: "", endPosition: "", identifierTypeEnd: null, endIdentifier: "", identifierType: null, populationColumn: "" });

function TransactionIdentifierModal({ colName, data, setData, allColumns, onClose, onDismiss, onSaved }) {
  const dis = onDismiss || onClose;
  const colOpts = allColumns.map(c => ({ value: c, label: c }));
  const [rows, setRows] = useState(data.txnIdentifier?.length ? data.txnIdentifier : [mkTxnRow()]);
  const save = () => { setData(p => ({ ...p, txnIdentifier: rows })); onSaved?.(); dis(); };
  return (
    <div className="sd-overlay" onClick={dis}>
      <div className="sd-modal sd-modal-xl" onClick={e => e.stopPropagation()}>
        <div className="sd-modal-header">
          <span className="sd-modal-title">Transaction Identifier</span>
          <button className="sd-modal-close" onClick={dis}>x</button>
        </div>
        <div className="sd-modal-body">
          <ScopeHint label={`Column: ${colName}`} />
          <FcRowContainer rows={rows} setRows={setRows} mkEmpty={mkTxnRow} renderRow={(row, i, upd) => (<>
            <div style={{ width: "100%", display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: "0.4rem" }}>
              <FcField label="Start Position"><FcInput value={row.startPosition} onChange={v => upd("startPosition", v)} placeholder="0" /></FcField>
              <FcField label="Start Identifier"><FcInput value={row.startIdentifier} onChange={v => upd("startIdentifier", v)} placeholder="Delimiter" /></FcField>
              <FcField label="ID Type (Start)"><PillSelect options={IDENTIFIER_TYPE_OPTIONS} value={row.identifierTypeStart} onChange={v => upd("identifierTypeStart", v)} /></FcField>
              <FcField label="Length"><FcInput value={row.length} onChange={v => upd("length", v)} placeholder="chars" /></FcField>
            </div>
            <div style={{ width: "100%", display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: "0.4rem" }}>
              <FcField label="End Position"><FcInput value={row.endPosition} onChange={v => upd("endPosition", v)} placeholder="0" /></FcField>
              <FcField label="End Identifier"><FcInput value={row.endIdentifier} onChange={v => upd("endIdentifier", v)} placeholder="Delimiter" /></FcField>
              <FcField label="ID Type (End)"><PillSelect options={IDENTIFIER_TYPE_OPTIONS} value={row.identifierTypeEnd} onChange={v => upd("identifierTypeEnd", v)} /></FcField>
              <FcField label="Identifier Type"><PillSelect options={IDENTIFIER_TYPE_OPTIONS} value={row.identifierType} onChange={v => upd("identifierType", v)} /></FcField>
            </div>
            <div style={{ width: "100%", display: "grid", gridTemplateColumns: "1fr 3fr", gap: "0.4rem" }}>
              <FcField label="Write Into Column"><PillSelect options={colOpts} value={colOpts.find(o => o.value === row.populationColumn) || null} onChange={o => upd("populationColumn", o?.value || "")} placeholder="Target column" /></FcField>
            </div>
            <hr className="sd-hr" />
          </>)} />
        </div>
        <div className="sd-modal-footer">
          <button className="sd-btn sd-btn-secondary" onClick={onClose}>Cancel</button>
          <button className="sd-btn sd-btn-success" onClick={save}>Save</button>
        </div>
      </div>
    </div>
  );
}

const mkFillRow = () => ({ action: null, valueToFill: "", excelCol: null, excelRow: null, targetColumn: "", condition: "", failValue: "", dropOriginal: null });

function FillRowsModal({ colName, data, setData, onClose, onDismiss, onSaved }) {
  const dis = onDismiss || onClose;
  const [rows, setRows] = useState(data.fill?.length ? data.fill : [mkFillRow()]);
  const save = () => { setData(p => ({ ...p, fill: rows })); onSaved?.(); dis(); };
  return (
    <div className="sd-overlay" onClick={dis}>
      <div className="sd-modal sd-modal-lg" onClick={e => e.stopPropagation()}>
        <div className="sd-modal-header">
          <span className="sd-modal-title">Fill Rows</span>
          <button className="sd-modal-close" onClick={dis}>x</button>
        </div>
        <div className="sd-modal-body">
          <ScopeHint label={`Column: ${colName}`} />
          <FcRowContainer rows={rows} setRows={setRows} mkEmpty={mkFillRow} renderRow={(row, i, upd) => (<>
            <FcField label="Action"><PillSelect options={FILL_OPTS} value={row.action} onChange={v => upd("action", v)} /></FcField>
            {row.action?.value === "fill_nulls" && (
              <FcField label="Value to Fill"><FcInput value={row.valueToFill} onChange={v => upd("valueToFill", v)} placeholder="Fill empty cells with" /></FcField>
            )}
            {row.action?.value === "fill_cell_values" && (<>
              <FcField label="Excel Column"><PillSelect options={COL_LETTER_OPTS} value={row.excelCol} onChange={v => upd("excelCol", v)} placeholder="A, B" /></FcField>
              <FcField label="Excel Row"><PillSelect options={ROW_NUM_OPTS} value={row.excelRow} onChange={v => upd("excelRow", v)} placeholder="1, 2" /></FcField>
              <FcField label="Target Column Name"><FcInput value={row.targetColumn} onChange={v => upd("targetColumn", v)} placeholder="Column to populate" /></FcField>
            </>)}
            {row.action?.value === "column_splitter" && (<>
              <FcField label="Split Condition"><FcInput value={row.condition} onChange={v => upd("condition", v)} placeholder="e.g. delimiter or rule" /></FcField>
              <FcField label="Value if Fails"><FcInput value={row.failValue} onChange={v => upd("failValue", v)} placeholder="Default value" /></FcField>
              <FcField label="Target Column"><FcInput value={row.targetColumn} onChange={v => upd("targetColumn", v)} placeholder="New column name" /></FcField>
              <FcField label="Drop Original"><PillSelect options={[{ value: "yes", label: "Yes" }, { value: "no", label: "No" }, { value: "both", label: "Keep Both" }]} value={row.dropOriginal} onChange={v => upd("dropOriginal", v)} /></FcField>
            </>)}
          </>)} />
        </div>
        <div className="sd-modal-footer">
          <button className="sd-btn sd-btn-secondary" onClick={onClose}>Cancel</button>
          <button className="sd-btn sd-btn-success" onClick={save}>Save</button>
        </div>
      </div>
    </div>
  );
}

// --- TABLE CONFIG MODAL ------------------------------------------------------
function TableConfigModal({ sheetName, tableConfig, onSave, onCancel }) {
  const [configType, setConfigType] = useState(tableConfig?.type || null);
  const [mysqlTable, setMysqlTable] = useState(tableConfig?.mysqlTable || null);
  const [customName, setCustomName] = useState(tableConfig?.customTableName || "");

  const save = () => {
    if (!configType) { alert("Please select a configuration type"); return; }
    if (configType === "mysql" && !mysqlTable) { alert("Please select a MySQL table"); return; }
    if (configType === "custom" && !customName.trim()) { alert("Please enter a table name"); return; }
    onSave({ type: configType, mysqlTable, customTableName: customName });
  };

  return (
    <div className="sd-overlay" onClick={onCancel}>
      <div className="sd-modal" onClick={e => e.stopPropagation()}>
        <div className="sd-modal-header">
          <span className="sd-modal-title">Table Configuration</span>
          <button className="sd-modal-close" onClick={onCancel}>x</button>
        </div>
        <div className="sd-modal-body">
          <ScopeHint global label={`Sheet: ${sheetName}`} />
          <div className="sd-field" style={{ marginBottom: "1rem" }}>
            <label className="sd-label">Configuration Type</label>
            <div style={{ display: "flex", gap: "0.8rem", marginTop: "0.5rem" }}>
              <label style={{ display: "flex", alignItems: "center", gap: "0.3rem", cursor: "pointer" }}>
                <input type="radio" checked={configType === "mysql"} onChange={() => setConfigType("mysql")} />
                MySQL Table
              </label>
              <label style={{ display: "flex", alignItems: "center", gap: "0.3rem", cursor: "pointer" }}>
                <input type="radio" checked={configType === "custom"} onChange={() => setConfigType("custom")} />
                Custom Input
              </label>
            </div>
          </div>

          {configType === "mysql" && (
            <div className="sd-field" style={{ marginBottom: "0.5rem" }}>
              <label className="sd-label">Select MySQL Table</label>
              <PillSelect
                options={[{ value: "orders", label: "orders" }, { value: "customers", label: "customers" }, { value: "products", label: "products" }]}
                value={mysqlTable}
                onChange={setMysqlTable}
                placeholder="Select table"
              />
            </div>
          )}

          {configType === "custom" && (
            <div className="sd-field">
              <label className="sd-label">Table Name</label>
              <input
                className="sd-input"
                value={customName}
                onChange={e => setCustomName(e.target.value)}
                placeholder="Enter table name"
              />
            </div>
          )}
        </div>
        <div className="sd-modal-footer">
          <button className="sd-btn sd-btn-secondary" onClick={onCancel}>Cancel</button>
          <button className="sd-btn sd-btn-success" onClick={save}>Save</button>
        </div>
      </div>
    </div>
  );
}

const mkRenameRow = () => ({ type: null, newName: "", schema: null, table: null, dbColumn: null });

function RenamingColumnsModal({ colName, data, setData, onClose, onDismiss, onSaved }) {
  const dis = onDismiss || onClose;
  const [rows, setRows] = useState(data.renaming?.length ? data.renaming : [mkRenameRow()]);
  const save = () => { setData(p => ({ ...p, renaming: rows })); onSaved?.(); dis(); };
  return (
    <div className="sd-overlay" onClick={dis}>
      <div className="sd-modal sd-modal-lg" onClick={e => e.stopPropagation()}>
        <div className="sd-modal-header">
          <span className="sd-modal-title">Renaming Columns</span>
          <button className="sd-modal-close" onClick={dis}>x</button>
        </div>
        <div className="sd-modal-body">
          <ScopeHint label={`Column: ${colName}`} />
          <FcRowContainer rows={rows} setRows={setRows} mkEmpty={mkRenameRow} renderRow={(row, i, upd) => (<>
            <FcField label="Rename Source"><PillSelect options={COLTYPE_OPTS} value={row.type} onChange={v => upd("type", v)} placeholder="Select type" /></FcField>
            {row.type?.value === "data_entry" && (
              <FcField label="New Name"><FcInput value={row.newName} onChange={v => upd("newName", v)} placeholder="Enter new column name" /></FcField>
            )}
            {row.type?.value === "database" && (<>
              <FcField label="Schema"><PillSelect options={DB_OPTS} value={row.schema} onChange={v => upd("schema", v)} /></FcField>
              <FcField label="Table"><PillSelect options={[]} value={row.table} onChange={v => upd("table", v)} placeholder="Table" /></FcField>
              <FcField label="Column"><PillSelect options={[]} value={row.dbColumn} onChange={v => upd("dbColumn", v)} placeholder="Column" /></FcField>
            </>)}
          </>)} />
        </div>
        <div className="sd-modal-footer">
          <button className="sd-btn sd-btn-secondary" onClick={onClose}>Cancel</button>
          <button className="sd-btn sd-btn-success" onClick={save}>Save</button>
        </div>
      </div>
    </div>
  );
}

const mkValCorrRow = () => ({ correctionType: null, valueToCheck: "", valueToReplace: "", fromDateFmt: null, toDateFmt: null });

function ValueCorrectionsModal({ colName, data, setData, onClose, onDismiss, onSaved }) {
  const dis = onDismiss || onClose;
  const [rows, setRows] = useState(data.valCorr?.length ? data.valCorr : [mkValCorrRow()]);
  const save = () => { setData(p => ({ ...p, valCorr: rows })); onSaved?.(); dis(); };
  return (
    <div className="sd-overlay" onClick={dis}>
      <div className="sd-modal sd-modal-lg" onClick={e => e.stopPropagation()}>
        <div className="sd-modal-header">
          <span className="sd-modal-title">Value Corrections</span>
          <button className="sd-modal-close" onClick={dis}>x</button>
        </div>
        <div className="sd-modal-body">
          <ScopeHint label={`Column: ${colName}`} />
          <FcRowContainer rows={rows} setRows={setRows} mkEmpty={mkValCorrRow} renderRow={(row, i, upd) => (<>
            <FcField label="Correction Type"><PillSelect options={CORR_OPTS} value={row.correctionType} onChange={v => upd("correctionType", v)} /></FcField>
            {row.correctionType?.value === "replace_values" && (<>
              <FcField label="Value to Find"><FcInput value={row.valueToCheck} onChange={v => upd("valueToCheck", v)} placeholder="Existing value" /></FcField>
              <FcField label="Replace With"><FcInput value={row.valueToReplace} onChange={v => upd("valueToReplace", v)} placeholder="New value" /></FcField>
            </>)}
            {row.correctionType?.value === "date_format" && (<>
              <FcField label="From Format"><PillSelect options={DATE_FORMAT_OPTIONS} value={row.fromDateFmt} onChange={v => upd("fromDateFmt", v)} /></FcField>
              <FcField label="To Format"><PillSelect options={DATE_FORMAT_OPTIONS} value={row.toDateFmt} onChange={v => upd("toDateFmt", v)} /></FcField>
            </>)}
          </>)} />
        </div>
        <div className="sd-modal-footer">
          <button className="sd-btn sd-btn-secondary" onClick={onClose}>Cancel</button>
          <button className="sd-btn sd-btn-success" onClick={save}>Save</button>
        </div>
      </div>
    </div>
  );
}

// -- Column-level TransformCell --
const COL_MODAL_MAP = {
  "Change Date Format": ChangeDateFormatModal,
  "Field Extraction": FieldExtractionModal,
  "Position": PositionModal,
  "Change Column Name": ChangeColumnNameModal,
  "Transaction Identifier": TransactionIdentifierModal,
  "Fill Rows": FillRowsModal,
  "Renaming Columns": RenamingColumnsModal,
  "Value Corrections": ValueCorrectionsModal,
};
const NEEDS_ALL_COLS = new Set(["Field Extraction", "Transaction Identifier"]);

function TransformCell({ colName, colData, setColData, allColumns }) {
  const [entries, setEntries] = useState(colData._entries || []);
  const [openId, setOpenId] = useState(null);
  const [addSel, setAddSel] = useState(null);
  const idRef = useRef(0);

  useEffect(() => {
    const savedEntries = colData._entries || [];
    setEntries(savedEntries);
    idRef.current = savedEntries.reduce((max, entry) => Math.max(max, Number(entry.id) || 0), 0);
  }, [colData]);

  const handleAdd = opt => {
    if (!opt) return;
    setAddSel(null);
    // If type already exists, reopen it
    const existing = entries.find(e => e.type === opt.value);
    if (existing) { setOpenId(existing.id); return; }
    const id = ++idRef.current;
    const nextEntries = [...entries, { id, type: opt.value, label: opt.label, saved: false }];
    setEntries(nextEntries);
    setColData(p => ({ ...p, _entries: nextEntries }));
    setOpenId(id);
  };

  const handleSave = id => {
    const nextEntries = entries.map(e => e.id === id ? { ...e, saved: true } : e);
    setEntries(nextEntries);
    setColData(p => ({ ...p, _entries: nextEntries }));
    setOpenId(null);
  };

  // Cancel button  remove pill if never saved
  const handleCancel = id => {
    const entry = entries.find(e => e.id === id);
    if (entry && !entry.saved) {
      const nextEntries = entries.filter(e => e.id !== id);
      setEntries(nextEntries);
      setColData(p => { const n = { ...p, _entries: nextEntries }; delete n[`col_entry_${id}`]; return n; });
    }
    setOpenId(null);
  };

  // Backdrop / close click just closes, never removes the unsaved pill.
  const handleDismiss = () => setOpenId(null);

  const handleRemove = id => {
    const nextEntries = entries.filter(e => e.id !== id);
    setEntries(nextEntries);
    setColData(p => { const n = { ...p, _entries: nextEntries }; delete n[`col_entry_${id}`]; return n; });
  };

  const openEntry = entries.find(e => e.id === openId);

  const renderModal = () => {
    if (!openEntry) return null;
    const Modal = COL_MODAL_MAP[openEntry.type];
    if (!Modal) return null;
    const entryKey = `col_entry_${openEntry.id}`;
    const props = {
      colName,
      data: colData[entryKey] || {},
      setData: fn => setColData(p => ({ ...p, [entryKey]: typeof fn === "function" ? fn(p[entryKey] || {}) : fn })),
      onClose: () => handleCancel(openEntry.id),   // Cancel button
      onDismiss: handleDismiss,                       // backdrop / ?
      onSaved: () => handleSave(openEntry.id),
    };
    if (NEEDS_ALL_COLS.has(openEntry.type)) props.allColumns = allColumns;
    return <Modal {...props} />;
  };

  // Only show types not yet added
  const availableOpts = COL_TRANSFORM_OPTIONS.filter(o => !entries.find(e => e.type === o.value));

  return (
    <div className="tc-wrap">
      {entries.length > 0 && (
        <div className="tc-list">
          {entries.map(e => (
            <div key={e.id} className={`tc-item${!e.saved ? " tc-item-unsaved" : ""}`}
              onClick={() => setOpenId(e.id)} title={`Edit: ${e.label}`}>
              <span className="tc-item-label">{e.label}</span>
              <button className="tc-item-del" title="Remove"
                onClick={ev => { ev.stopPropagation(); handleRemove(e.id); }}>x</button>
            </div>
          ))}
        </div>
      )}
      {availableOpts.length > 0 && (
        <Select
          options={availableOpts} value={addSel} onChange={handleAdd}
          placeholder="+ Add transform"
          classNamePrefix="react-select" className="sd-react-select"
          menuPortalTarget={null}
          menuPlacement="bottom"
          menuPosition="absolute" styles={PORTAL_STYLES}
        />
      )}
      {renderModal()}
    </div>
  );
}

// --- ColumnRow ----------------------------------------------------------------

// Helper function to generate default validations based on data type
const getDefaultValidationForType = (dataTypeValue, colName) => {
  const validations = [];
  
  if (dataTypeValue === "/api/v2/user_modules/string_validation/") {
    // Text: 1 to 100
    validations.push({ [colName]: { Length: ["1", "100"] } });
  } else if (dataTypeValue === "/api/v2/user_modules/integer_validation/") {
    // Integer: 1 to 25
    validations.push({ [colName]: { Length: ["1", "25"] } });
  } else if (dataTypeValue === "/api/v2/user_modules/decimal_validation/") {
    // Decimal: 1 to 25
    validations.push({ [colName]: { Length: ["1", "25"] } });
  } else if (dataTypeValue === "/api/v2/user_modules/date_validation/") {
    // Date: 1 to 15 (length validation)
    validations.push({ [colName]: { Length: ["1", "15"] } });
  }
  
  return validations;
};

function ColumnRow({ item, isNew, onDelete, onRename, sheetConfig, updateConfig, colData, setColData, allColumns, property, setProperty, primaryKey, setPrimaryKey }) {
  const [showVal, setShowVal] = useState(false);
  const [editing, setEditing] = useState(false);
  const [editVal, setEditVal] = useState(item.col_name);
  const [displayName, setDisplay] = useState(item.col_name);

  useEffect(() => {
    setDisplay(item.col_name);
    setEditVal(item.col_name);
  }, [item.col_name]);

  const { actionsDatatype, validationDatatype, mandataryData } = sheetConfig;
  const currentDT = actionsDatatype.find(a => a[item.col_name] !== undefined)?.[item.col_name] || "";
  const handleDTChange = opt => {
    const updates = {
      actionsDatatype: [...actionsDatatype.filter(a => a[item.col_name] === undefined), { [item.col_name]: opt?.value }],
    };
    
    // Apply default validations based on data type
    if (opt?.value) {
      const defaultValidations = getDefaultValidationForType(opt.value, item.col_name);
      const existingValidations = validationDatatype.filter(v => v[item.col_name] === undefined);
      updates.validationDatatype = [...existingValidations, ...defaultValidations];
      
      // For date types, also add default date format transformation
      if (opt.value === "/api/v2/user_modules/date_validation/") {
        const newColData = {
          ...colData,
          dateFormat: { from: "%d-%m-%Y", to: "%d-%m-%Y" },
        };
        setColData(fn => typeof fn === "function" ? fn(newColData) : newColData);
      }
    }
    
    updateConfig(updates);
  };
  const valCount = validationDatatype.filter(v => v[item.col_name] !== undefined).length;

  const commitRename = () => {
    const trimmed = editVal.trim();
    if (trimmed && trimmed !== item.col_name) {
      const renamed = onRename(item.col_name, trimmed);
      if (renamed) setDisplay(trimmed);
      else setEditVal(displayName);
    } else if (trimmed) setDisplay(trimmed);
    else setEditVal(displayName);
    setEditing(false);
  };

  return (
    <>
      <tr className={isNew ? "sd-new-row" : ""}>
        <td style={{ color: "#999", fontFamily: "'DM Mono',monospace", fontSize: "0.7rem", textAlign: "center", width: 30 }}>{item.id}</td>
        <td style={{ width: 140 }}>
          <div className="sd-col-name-wrap">
            {editing
              ? <input className="sd-input" value={editVal} autoFocus style={{ height: 24, fontSize: "0.74rem" }}
                onChange={e => setEditVal(e.target.value)}
                onBlur={commitRename}
                onKeyDown={e => { if (e.key === "Enter") commitRename(); if (e.key === "Escape") { setEditVal(displayName); setEditing(false); } }}
              />
              : <>
                <span className="sd-col-name-static" title={displayName}>{displayName}</span>
                <button className="sd-col-rename-btn" title="Rename" onClick={() => { setEditVal(displayName); setEditing(true); }}>Edit</button>
              </>
            }
          </div>
        </td>
        <td style={{ width: 118 }}>
          <PillSelect options={DATA_TYPE_OPTIONS} value={DATA_TYPE_OPTIONS.find(o => o.value === currentDT) || null} onChange={handleDTChange} />
        </td>
        <td style={{ width: 100 }}>
          <input className="sd-input" placeholder="Property" value={property || ""} onChange={e => setProperty(item.col_name, e.target.value)} style={{ height: 24, fontSize: "0.74rem" }} />
        </td>
        <td style={{ width: 108 }}>
          <button className="sd-btn sd-btn-secondary sd-btn-sm" onClick={() => setShowVal(true)}>
            Validation{valCount > 0 && <span className="sd-badge sd-badge-count">{valCount}</span>}
          </button>
        </td>
        <td>
          <TransformCell colName={item.col_name} colData={colData} setColData={setColData} allColumns={allColumns} />
        </td>
        <td style={{ textAlign: "center", width: 34 }}>
          <input type="checkbox" className="sd-checkbox" checked={!!primaryKey} onChange={e => setPrimaryKey(item.col_name, e.target.checked)} />
        </td>
        <td style={{ textAlign: "center", width: 30 }}>
          <button className="sd-delete-col-btn" title="Remove column" onClick={() => onDelete(item.col_name)}></button>
        </td>
      </tr>
      {showVal && (
        <ValidationModal colName={item.col_name}
          validationDatatype={validationDatatype}
          setValidationDatatype={v => updateConfig({ validationDatatype: v })}
          mandataryData={mandataryData}
          setMandataryData={m => updateConfig({ mandataryData: m })}
          onClose={() => setShowVal(false)} />
      )}
    </>
  );
}

// --- Main ---------------------------------------------------------------------

export default function SourceDefinition() {
  const [sourceName, setSourceName] = useState("");
  const [identifier, setIdentifier] = useState("");
  const [description, setDescription] = useState("");
  const [sourceType, setSourceType] = useState(null);
  const [fileInputKey, setFileInputKey] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [startRow, setStartRow] = useState("");
  const [activeSheet, setActiveSheet] = useState(null);
  const [sheetConfigs, setSheetConfigs] = useState({});

  const [existingSources, setExistingSources] = useState([]);
  const [selectedExisting, setSelectedExisting] = useState(null);
  const [isExistingMode, setIsExistingMode] = useState(false);
  const [isInputDisabled, setIsInputDisabled] = useState(false);

  const [sheets, setSheets] = useState([]);
  const [columns, setColumns] = useState([]);


  const [status, setStatus] = useState(null);
  const [saving, setSaving] = useState(false);
  const [showTableConfig, setShowTableConfig] = useState(false);

  const apiDataRef = useRef(null);
  const nextIdRef = useRef(1000);

  // Get current sheet name
  const currentSheetName = sheets[activeSheet]?.sht_name || `Sheet ${activeSheet + 1}`;

  // Get configuration for current sheet
  const getCurrentSheetConfig = () => sheetConfigs[currentSheetName] || {
    properties: {},
    actionsDatatype: [],
    validationDatatype: [],
    mandataryData: [],
    colTransformData: {},
    consolidatedData: {},
    primaryKeys: {},
    tableConfig: { type: null, mysqlTable: null, customTableName: "" },
  };

  // Update configuration for current sheet
  const updateCurrentSheetConfig = (updates) => {
    setSheetConfigs(prev => ({
      ...prev,
      [currentSheetName]: { ...getCurrentSheetConfig(), ...updates },
    }));
  };

  const allColumnNames = columns.map(c => c.col_name);

  useEffect(() => {
    loadExistingSources();
  }, []);

  function readUserCredentials() {
    try {
      return JSON.parse(sessionStorage.getItem("userCredentials") || "{}");
    } catch {
      return {};
    }
  }

  function normalizeActions(actions, sheetIndex) {
    const actionEnvelope = Array.isArray(actions) ? actions[0] : actions;
    const sheetAction = actionEnvelope?.[String(sheetIndex + 1)] || actionEnvelope?.[1] || [];
    const getBlock = name => sheetAction.find(item => item && Object.prototype.hasOwnProperty.call(item, name))?.[name];
    const transform = getBlock("Transform") || {};
    return {
      actionsDatatype: getBlock("Data_type") || [],
      validationDatatype: getBlock("Validation") || [],
      mandataryData: getBlock("Mandatary") || [],
      colTransformData: transform.columnTransforms || transform.colTransformData || {},
      consolidatedData: transform.consolidatedTransforms || transform.consolidatedData || {},
      primaryKeys: getBlock("Primary_key") || {},
      properties: getBlock("Properties") || {},
      startRow: getBlock("start_col_row") || "",
    };
  }

  function buildActionsPayload(configEntries) {
    return configEntries.reduce((acc, [sheetName, config], index) => {
      acc[index + 1] = [
        { Data_type: config.actionsDatatype || [] },
        { Validation: config.validationDatatype || [] },
        {
          Transform: {
            columnTransforms: config.colTransformData || {},
            consolidatedTransforms: config.consolidatedData || {},
          },
        },
        { Mandatary: config.mandataryData || [] },
        { start_col_row: startRow },
        { Primary_key: config.primaryKeys || {} },
        { Properties: config.properties || {} },
        { sheet_name: sheetName },
      ];
      return acc;
    }, {});
  }

  function sheetRowsFromData(data) {
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.columns)) return data.columns.flat();
    if (Array.isArray(data?.data)) return data.data;
    return [];
  }

  function loadExistingSources() {
    const payload = { File_data: "hi" };
    const credentials = SheetData();
    axios.post(credentials[1], payload, credentials[0])
      .then(response => {
        const names = (Array.isArray(response.data) ? response.data : []).map(item => ({
          value: item.source_id,
          label: item.source_name,
        }));
        setExistingSources(names);
      })
      .catch(error => {
        console.log("Error loading source names", error);
      });
  }

  function loadExistingConfig(opt) {
    if (!opt?.value) return;
    setStatus("loading");
    const credentials = FileUploadToServernew();
    axios.post(credentials[1], { id: opt.value }, credentials[0])
      .then(response => {
        const data = response.data || {};
        const rawSheets = sheetRowsFromData(data).filter(sheet => sheet && Array.isArray(sheet.column_names));
        if (!rawSheets.length) {
          setStatus("error");
          return;
        }
        apiDataRef.current = rawSheets;
        setSheets(rawSheets.map((sheet, index) => ({ id: index, sht_name: sheet.sheet_name || `Sheet ${index + 1}` })));

        const nextConfigs = {};
        rawSheets.forEach((sheet, index) => {
          const sheetName = sheet.sheet_name || `Sheet ${index + 1}`;
          const actionConfig = normalizeActions(data.actions, index);
          nextConfigs[sheetName] = {
            properties: actionConfig.properties,
            actionsDatatype: actionConfig.actionsDatatype,
            validationDatatype: actionConfig.validationDatatype,
            mandataryData: actionConfig.mandataryData,
            colTransformData: actionConfig.colTransformData,
            consolidatedData: actionConfig.consolidatedData,
            primaryKeys: actionConfig.primaryKeys,
          };
          if (index === 0 && actionConfig.startRow !== "") setStartRow(String(actionConfig.startRow));
        });

        const meta = data.data?.[0] || {};
        setSourceName(meta.source_name || opt.label || "");
        setIdentifier(meta.source_identifier || "");
        setDescription(meta.source_description || "");
        setSourceType(SOURCE_TYPE_OPTIONS.find(item => item.value === meta.source_type) || null);
        setSheetConfigs(nextConfigs);
        setColumns(rawSheets[0].column_names.map((name, i) => ({ id: i + 1, col_name: name, isNew: false })));
        setActiveSheet(0);
        setStatus("ready");
      })
      .catch(error => {
        console.log("Error loading source configuration", error);
        setStatus("error");
      });
  }

  function resetAll() {
    setSourceName(""); setIdentifier(""); setDescription("");
    setSourceType(null); setSelectedExisting(null); setIsInputDisabled(false);
    setStartRow(""); setSelectedFile(null);
    setSheets([]); setActiveSheet(0); setColumns([]);
    setSheetConfigs({});
    setStatus(null); setSaving(false);
    apiDataRef.current = null; setFileInputKey(k => k + 1);
  }

  function inferType(samples) {
    const vals = samples.map(v => String(v).trim()).filter(v => v !== "" && v !== "null" && v !== "undefined");
    if (!vals.length) return "";
    const dateRe = /^(\d{1,4}[-/.]\d{1,2}[-/.]\d{1,4})|(\d{1,2}[-/.][a-zA-Z]{3}[-/.]\d{2,4})|(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i;
    const timeRe = /^\d{1,2}:\d{2}(:\d{2})?(\s?(am|pm))?$/i;
    const intRe = /^-?\d+$/;
    const decRe = /^-?\d+[.,]\d+$/;
    let dateCount = 0, timeCount = 0, intCount = 0, decCount = 0;
    for (const v of vals) {
      if (timeRe.test(v)) timeCount++;
      else if (dateRe.test(v)) dateCount++;
      else if (intRe.test(v)) intCount++;
      else if (decRe.test(v)) decCount++;
    }
    const total = vals.length;
    const pct = n => n / total;
    if (pct(timeCount) >= 0.6) return "/api/v2/user_modules/time_validation/";
    if (pct(dateCount) >= 0.6) return "/api/v2/user_modules/date_validation/";
    if (pct(decCount) >= 0.6) return "/api/v2/user_modules/decimal_validation/";
    if (pct(intCount) >= 0.6) return "/api/v2/user_modules/integer_validation/";
    return "/api/v2/user_modules/string_validation/";
  }

  function processApiResponse(data) {
    let rawSheets = null;
    if (Array.isArray(data)) rawSheets = data;
    else if (Array.isArray(data.columns)) rawSheets = data.columns.flat();
    else if (Array.isArray(data.data)) rawSheets = data.data;
    if (rawSheets) rawSheets = rawSheets.filter(d => d && Array.isArray(d.column_names));
    if (!rawSheets?.length) { setStatus("error"); return; }
    setSheets(rawSheets.map((d, i) => ({ id: i, sht_name: d.sheet_name || `Sheet ${i + 1}` })));

    // Initialize configs for all sheets
    const newConfigs = {};
    rawSheets.forEach((sheet, idx) => {
      const sheetName = sheet.sheet_name || `Sheet ${idx + 1}`;
      const inferred = sheet.column_names.map((name, i) => ({
        [name]: sheet.col_samples ? inferType(sheet.col_samples[i] || []) : "",
      }));
      newConfigs[sheetName] = {
        properties: {},
        actionsDatatype: inferred.filter(e => Object.values(e)[0] !== ""),
        validationDatatype: [],
        mandataryData: [],
        colTransformData: {},
        consolidatedData: {},
        primaryKeys: {},
        tableConfig: { type: null, mysqlTable: null, customTableName: "" },
      };
    });
    setSheetConfigs(newConfigs);

    // Load first sheet
    const firstSheet = rawSheets[0];
    setColumns(firstSheet.column_names.map((name, i) => ({ id: i + 1, col_name: name, isNew: false })));
    setActiveSheet(0);
    setStatus("ready");
  }

  function switchSheet(index) {
    if (!apiDataRef.current) return;
    const d = apiDataRef.current;
    const raw = (Array.isArray(d) ? d : Array.isArray(d.columns) ? d.columns.flat() : Array.isArray(d.data) ? d.data : []).filter(s => s && Array.isArray(s.column_names));
    const sheet = raw[index];
    if (!sheet) return;

    // Switch active sheet
    setActiveSheet(index);
    // Load columns for the new sheet
    setColumns(sheet.column_names.map((name, i) => ({ id: i + 1, col_name: name, isNew: false })));
  }

  function deleteSheet(index) {
    if (sheets.length === 1) { alert("Cannot delete the last sheet."); return; }
    const sheetName = sheets[index]?.sht_name || `Sheet ${index + 1}`;
    if (!window.confirm(`Delete sheet "${sheetName}" and all its configurations?`)) return;

    // Remove sheet from list
    setSheets(prev => prev.filter((_, i) => i !== index));
    
    // Remove sheet config
    setSheetConfigs(prev => {
      const newConfigs = { ...prev };
      delete newConfigs[sheetName];
      return newConfigs;
    });

    // Remove from API data
    if (apiDataRef.current) {
      apiDataRef.current = apiDataRef.current.filter((_, i) => i !== index);
    }

    // Switch to previous or next sheet
    const newActiveSheet = activeSheet > index ? activeSheet - 1 : activeSheet;
    if (newActiveSheet < sheets.length - 1) {
      switchSheet(newActiveSheet);
    }
  }

  function fetchConfig() {
    if (!selectedFile) { alert("Please select a file first."); return; }
    setStatus("loading");
    const reader = new FileReader();
    reader.onload = e => {
      try {
        const data = new Uint8Array(e.target.result);
        const wb = XLSX.read(data, { type: "array", cellDates: true });
        const sheets = wb.SheetNames.map(name => {
          const ws = wb.Sheets[name];
          const rows = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "", raw: false });
          const skip = Math.max(0, parseInt(startRow || "0", 10));

          // startRow is always the header row
          const headerRow = (rows[skip] || []).map(c => String(c).trim()).filter(c => c !== "");
          if (!headerRow.length) return null;

          const dataRows = rows.slice(skip + 1, skip + 21);
          const col_samples = headerRow.map((_, ci) =>
            dataRows.map(r => r[ci]).filter(v => v !== "" && v != null)
          );
          return { sheet_name: name, column_names: headerRow, col_samples };
        }).filter(Boolean).filter(s => s.column_names.length > 0);


        
        if (!sheets.length) { alert("No sheets or columns found. Check the file format and start row."); setStatus("error"); return; }
        apiDataRef.current = sheets;
        processApiResponse(sheets);
      } catch (err) {
        console.error(err);
        setStatus("error");
      }
    };
    reader.onerror = () => { alert("Failed to read file."); setStatus("error"); };
    reader.readAsArrayBuffer(selectedFile);
  }

  function addBlankColumn() {
    const id = nextIdRef.current++;
    const colName = `new_column_${id}`;
    setColumns(p => [...p, { id, col_name: colName, isNew: true }]);
    if (apiDataRef.current?.[activeSheet]) {
      apiDataRef.current = apiDataRef.current.map((sheet, index) =>
        index === activeSheet ? { ...sheet, column_names: [...sheet.column_names, colName] } : sheet
      );
    }
  }

  function deleteColumn(colName) {
    setColumns(p => p.filter(c => c.col_name !== colName));
    if (apiDataRef.current?.[activeSheet]) {
      apiDataRef.current = apiDataRef.current.map((sheet, index) =>
        index === activeSheet ? { ...sheet, column_names: sheet.column_names.filter(name => name !== colName) } : sheet
      );
    }
    const config = getCurrentSheetConfig();
    updateCurrentSheetConfig({
      properties: Object.fromEntries(Object.entries(config.properties).filter(([k]) => k !== colName)),
      colTransformData: Object.fromEntries(Object.entries(config.colTransformData).filter(([k]) => k !== colName)),
      primaryKeys: Object.fromEntries(Object.entries(config.primaryKeys || {}).filter(([k]) => k !== colName)),
      actionsDatatype: config.actionsDatatype.filter(a => a[colName] === undefined),
      validationDatatype: config.validationDatatype.filter(v => v[colName] === undefined),
      mandataryData: config.mandataryData.filter(v => v[colName] === undefined),
    });
  }

  function renameColumn(oldName, newName) {
    if (oldName === newName) return true;
    if (columns.some(c => c.col_name === newName)) {
      alert("A column with this name already exists.");
      return false;
    }
    const renameKeyedObject = obj => Object.fromEntries(Object.entries(obj || {}).map(([key, value]) => [key === oldName ? newName : key, value]));
    const renameRuleArray = arr => (arr || []).map(rule => {
      if (!Object.prototype.hasOwnProperty.call(rule, oldName)) return rule;
      return { [newName]: rule[oldName] };
    });

    setColumns(prev => prev.map(col => col.col_name === oldName ? { ...col, col_name: newName } : col));
    if (apiDataRef.current?.[activeSheet]) {
      apiDataRef.current = apiDataRef.current.map((sheet, index) =>
        index === activeSheet
          ? { ...sheet, column_names: sheet.column_names.map(name => name === oldName ? newName : name) }
          : sheet
      );
    }

    const config = getCurrentSheetConfig();
    updateCurrentSheetConfig({
      properties: renameKeyedObject(config.properties),
      colTransformData: renameKeyedObject(config.colTransformData),
      primaryKeys: renameKeyedObject(config.primaryKeys),
      actionsDatatype: renameRuleArray(config.actionsDatatype),
      validationDatatype: renameRuleArray(config.validationDatatype),
      mandataryData: renameRuleArray(config.mandataryData),
    });
    return true;
  }

  function setPrimaryKey(colName, checked) {
    const config = getCurrentSheetConfig();
    updateCurrentSheetConfig({
      primaryKeys: { ...(config.primaryKeys || {}), [colName]: checked },
    });
  }

  function handleSave() {
    if (!sourceName) { alert("Enter source name."); return; }
    if (!identifier) { alert("Enter identifier."); return; }
    if (!description) { alert("Enter description."); return; }
    if (!sourceType?.value && !isExistingMode) { alert("Select source type."); return; }
    setSaving(true);
    const configEntries = Object.entries(sheetConfigs);
    const actions = buildActionsPayload(configEntries);
    const rawSheets = apiDataRef.current || [];
    const sheetData = rawSheets.map((sheet, index) => ({
      id: sheet.id ?? index,
      text: sheet.sheet_name || `Sheet ${index + 1}`,
    }));

    if (isExistingMode && selectedExisting?.value) {
      const payload = {
        source_id: selectedExisting.value,
        actions,
        file_path: "",
        papulationcolumnlist: allColumnNames,
      };
      const credentials = UploadEditSheetData();
      axios.post(credentials[1], payload, credentials[0])
        .then(() => {
          alert("Source config file is successfully stored.");
          setSaving(false);
        })
        .catch(error => {
          console.log("Error saving source configuration", error);
          alert("Error saving the source config file.");
          setSaving(false);
        });
      return;
    }

    const userCredentials = readUserCredentials();
    const payload = {
      File_data: rawSheets,
      sheet_data: sheetData,
      source_type: sourceType?.value || "",
      source_name: sourceName,
      file_path: "",
      source_description: description,
      source_identifier: identifier,
      actions,
      papulationcolumnlist: allColumnNames,
      process_name: "etl_consolidation",
      file_name: selectedFile?.name || "",
      tenants_id: userCredentials.tenants_id,
      groups_id: userCredentials.groups_id,
      entities_id: userCredentials.entities_id,
      user_id: userCredentials.user_id,
      m_processing_layer_id: userCredentials.m_processing_layer_id,
      m_processing_sub_layer_id: userCredentials.m_processing_sub_layer_id,
      processing_layer_id: userCredentials.processing_layer_id,
    };

    const credentials = SheetDataUpload();
    axios.post(credentials[1], payload, credentials[0])
      .then(() => {
        alert("File config is successfully stored.");
        setSaving(false);
        loadExistingSources();
      })
      .catch(error => {
        console.log("Error saving configuration", error);
        alert("Error saving the config file. Source name or identifier may already exist.");
        setSaving(false);
      });
  }

  const setProperty = (col, val) => {
    const config = getCurrentSheetConfig();
    updateCurrentSheetConfig({
      properties: { ...config.properties, [col]: val },
    });
  };
  const getColData = col => {
    const config = getCurrentSheetConfig();
    return config.colTransformData[col] || {};
  };
  const makeSetColData = col => fn => {
    const config = getCurrentSheetConfig();
    const colData = config.colTransformData[col] || {};
    updateCurrentSheetConfig({
      colTransformData: {
        ...config.colTransformData,
        [col]: typeof fn === "function" ? fn(colData) : fn,
      },
    });
  };

  return (
    <>
      <style>{css}</style>
      <div className="sd-root">
        <div style={{ marginBottom: "0.55rem", display: "flex", alignItems: "baseline", gap: "0.6rem" }}>
          <h1 style={{ fontSize: "1rem", fontWeight: 700, letterSpacing: "-0.01em" }}>Source Definition</h1>
          <span style={{ color: "#888", fontSize: "0.72rem" }}>ETL source configuration</span>
        </div>

        {/* -- Source Config -- */}
        <div className="sd-card">
          <div style={{ display: "flex", alignItems: "center", gap: "0.6rem", marginBottom: "0.6rem", flexWrap: "wrap" }}>
            <div className="sd-mode-toggle">
              <button className={`sd-mode-btn ${!isExistingMode ? "active" : ""}`} onClick={() => { resetAll(); setIsExistingMode(false); setIsInputDisabled(false); }}>New Upload</button>
              <button className={`sd-mode-btn ${isExistingMode ? "active" : ""}`} onClick={() => { resetAll(); setIsExistingMode(true); setIsInputDisabled(true); }}>Existing</button>
            </div>
            {isExistingMode && (
              <div style={{ flex: 1, maxWidth: 300 }}>
                <PillSelect options={existingSources} value={selectedExisting} placeholder="Search sources"
                  onChange={opt => {
                    setSelectedExisting(opt);
                    if (!opt) { resetAll(); setIsExistingMode(true); setIsInputDisabled(true); return; }
                    setIsExistingMode(true);
                    setIsInputDisabled(true);
                    loadExistingConfig(opt);
                  }} />
              </div>
            )}
          </div>
          <div className="sd-fields-row">
            <div className="sd-field-item" style={{ flex: "2 1 140px" }}>
              <label className="sd-label">Source Name</label>
              <input className="sd-input" disabled={isInputDisabled} placeholder="e.g. Sales Q1" value={sourceName} onChange={e => setSourceName(e.target.value)} />
            </div>
            <div className="sd-field-item" style={{ flex: "1.5 1 120px" }}>
              <label className="sd-label">Identifier</label>
              <input className="sd-input" disabled={isInputDisabled} placeholder="Unique key" value={identifier} onChange={e => setIdentifier(e.target.value)} />
            </div>
            <div className="sd-field-item" style={{ flex: "2 1 140px" }}>
              <label className="sd-label">Description</label>
              <input className="sd-input" disabled={isInputDisabled} placeholder="Short description" value={description} onChange={e => setDescription(e.target.value)} />
            </div>
            <div className="sd-field-item" style={{ flex: "0 0 120px" }}>
              <label className="sd-label">Source Type</label>
              <PillSelect options={SOURCE_TYPE_OPTIONS} value={sourceType} onChange={setSourceType} isDisabled={isInputDisabled} placeholder="Type" />
            </div>
            {!isExistingMode && (<>
              <div className="sd-field-item" style={{ flex: "0 0 175px" }}>
                <label className="sd-label">File</label>
                <input key={fileInputKey} className="sd-input" type="file" accept=".xlsx,.xlsb,.xls,.csv,.txt" disabled={isInputDisabled} onChange={e => setSelectedFile(e.target.files[0] || null)} />
              </div>
              <div className="sd-field-item" style={{ flex: "0 0 68px" }}>
                <label className="sd-label">Start Row</label>
                <input className="sd-input" type="number" min="0" placeholder="0" value={startRow} onChange={e => setStartRow(e.target.value)} />
              </div>
            </>)}
            <div className="sd-field-btns">
              {status && (
                <span className={`sd-badge sd-badge-${status}`}>
                  {status === "loading" ? "Loading" : status === "ready" ? "Ready" : "Error"}
                </span>
              )}
              {!isExistingMode && (
                <button className="sd-btn sd-btn-primary" onClick={fetchConfig} disabled={status === "loading"}>Fetch</button>
              )}
              {status === "ready" && (
                <button className="sd-btn sd-btn-success" onClick={handleSave} disabled={saving}>{saving ? "Saving" : "Save"}</button>
              )}
            </div>
          </div>
        </div>

        {status === "ready" && columns.length > 0 && (<>

          {/* -- Consolidated Transforms Card -- */}
          <div className="sd-card-consolidated">
            <ConsolidatedTransformPanel
              consolidatedData={getCurrentSheetConfig().consolidatedData}
              updateConsolidatedData={data => updateCurrentSheetConfig({ consolidatedData: data })}
              allColumns={allColumnNames}
            />
          </div>

          {/* -- Source Columns Card -- */}
          <div className="sd-card" style={{ borderColor: "#93c5fd", position: "relative", paddingLeft: "1.2rem" }}>
            <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 4, background: "linear-gradient(180deg,#3b82f6,#1d4ed8)", borderRadius: "18px 0 0 18px" }}></div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "0.5rem" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap" }}>
                <span className="sd-card-title">Source Columns</span>
                {sheets.length > 1 && sheets.map((s, i) => (
                  <div key={s.id} style={{ display: "flex", alignItems: "center", gap: "0.25rem" }}>
                    <button onClick={() => switchSheet(i)} style={{
                      padding: "0.18rem 0.65rem", fontSize: "0.68rem", fontWeight: activeSheet === i ? 700 : 500,
                      border: activeSheet === i ? "1.5px solid #1a1a18" : "1px solid #e0e0e0",
                      borderRadius: "999px 0 0 999px", background: activeSheet === i ? "#1a1a18" : "#fff",
                      color: activeSheet === i ? "#fff" : "#888", cursor: "pointer", transition: "all 0.15s",
                    }}>{s.sht_name}</button>
                    <button onClick={() => deleteSheet(i)} title="Delete sheet" style={{
                      padding: "0.18rem 0.5rem", fontSize: "0.68rem", fontWeight: 500,
                      border: activeSheet === i ? "1.5px solid #1a1a18" : "1px solid #e0e0e0",
                      borderRadius: "0 999px 999px 0", background: activeSheet === i ? "#1a1a18" : "#fff",
                      color: activeSheet === i ? "#fff" : "#888", cursor: "pointer", transition: "all 0.15s",
                      display: "flex", alignItems: "center", justifyContent: "center", width: 24, height: 24,
                    }}>✕</button>
                  </div>
                ))}
              </div>
              <div style={{ display: "flex", gap: "0.3rem" }}>
                <button className="sd-btn sd-btn-secondary sd-btn-sm" onClick={() => setShowTableConfig(true)}>⚙ Table Config</button>
                <button className="sd-btn sd-btn-secondary sd-btn-sm" onClick={addBlankColumn}>+ Add Column</button>
              </div>
            </div>
            <div className="sd-table-wrap">
              <table className="sd-table" style={{ tableLayout: "auto" }}>
                <thead>
                  <tr>
                    <th style={{ width: 30 }}>#</th>
                    <th style={{ width: 140 }}>Column Name</th>
                    <th style={{ width: 118 }}>Data Type</th>
                    <th style={{ width: 100 }}>Property</th>
                    <th style={{ width: 108 }}>Validation</th>
                    <th style={{ minWidth: 190 }}>Transform <span style={{ fontWeight: 400, opacity: 0.6, textTransform: "none", letterSpacing: 0 }}>(per column)</span></th>
                    <th style={{ width: 34 }}>PK</th>
                    <th style={{ width: 30 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {columns.map(item => {
                    const config = getCurrentSheetConfig();
                    return (
                      <ColumnRow key={item.col_name} item={item} isNew={item.isNew} onDelete={deleteColumn} onRename={renameColumn}
                        sheetConfig={config}
                        updateConfig={updateCurrentSheetConfig}
                        colData={getColData(item.col_name)} setColData={makeSetColData(item.col_name)}
                        allColumns={allColumnNames}
                        property={config.properties[item.col_name]} setProperty={setProperty}
                        primaryKey={config.primaryKeys?.[item.col_name]} setPrimaryKey={setPrimaryKey}
                      />
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </>)}
      </div>

      {showTableConfig && (
        <TableConfigModal 
          sheetName={currentSheetName}
          tableConfig={getCurrentSheetConfig().tableConfig}
          onSave={(config) => updateCurrentSheetConfig({ tableConfig: config })}
          onCancel={() => setShowTableConfig(false)}
        />
      )}
    </>
  );
}
